{
  "USD": "USD",
  "GBP": "GBP",
  "EUR": "EUR",
  "AUD": "AUD",
  "general": {
    "login": "Anmelden",
    "email-address": "E-Mail-Adresse",
    "failed": "Fehlgeschlagen",
    "processing": "Wird verarbeitet",
    "app-loading": "App wird geladen",
    "loading": "Wird geladen",
    "team-members": "Mitglieder",
    "spaces-available": "Plätze verfügbar",
    "office-full": "Ausgebucht",
    "AM": "Vormittags",
    "PM": "Nachmittags",
    "am-only": "Nur Vormittags",
    "pm-only": "Nur Nachmittags",
    "add": "Hinzufügen",
    "desks-available": "Schreibtische verfügbar",
    "successfully-logged-out": "Erfolgreich abgemeldet",
    "admin": "(Admin)",
    "no-team": "Kein Team",
    "or": "Oder",
    "no-department": "-- Keine Abteilung --",
    "select-department": "-- Abteilung auswählen --",
    "all-teams": "Alle Teams",
    "select-team": "-- Team auswählen --",
    "first-monday": "Erster Montag im",
    "first-day": "Erster Tag im",
    "name": "Name",
    "full-name": "Vollständiger Name",
    "how-it-works": "So funktioniert es",
    "description": "Beschreibung"
  },
  "errors": {
    "email-in-use": {
      "title": "Diese E-Mail-Adresse wird bereits verwendet.",
      "message": "Wenn Sie bereits registriert sind, aber zu Google oder Microsoft wechseln möchten, kontaktieren Sie uns unter <0>hello@team-today.com</0>, und wir können Ihr Konto migrieren."
    },
    "email-exists": {
      "message": "Versuchen Sie, sich <0>anzumelden</0>, oder kontaktieren Sie uns unter <1>hello@team-today.com</1>, und wir helfen Ihnen weiter.",
      "logging-in": "anzumelden"
    },
    "company-already-registered": {
      "title": "Ihr Unternehmen hat bereits ein Konto.",
      "message": "Bitten Sie einen anderen Nutzer Ihres Unternehmens um eine Einladung. Wenn Sie bereits ein Konto haben, versuchen Sie, sich <0>anzumelden</0>.",
      "logging-in": "anzumelden"
    },
    "general": {
      "title": "Bei Ihrer Registrierung ist ein Fehler aufgetreten.",
      "message": "Versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns unter <0>hello@team-today.com</0>, und wir helfen Ihnen weiter."
    },
    "no-account-registered": {
      "title": "Bei Ihrer Registrierung ist ein Fehler aufgetreten.",
      "message": "Sie können ein Konto registrieren oder einen Kollegen um eine Einladung bitten. Wenn Sie glauben, bereits ein Konto zu haben, kontaktieren Sie bitte <0>support@team-today.com</0>.",
      "button": "Neues Konto registrieren"
    },
    "azure": {
      "consent-message": {
        "message-1": "Damit Team Today mit <strong>Microsoft 365</strong> funktioniert, benötigen wir die Berechtigung, sicher auf Ihre <strong>Kalender- und E-Mail-Einstellungen</strong> zuzugreifen.",
        "message-2": "Bitte stellen Sie sicher, dass Sie die Checkboxen für die Berechtigungen ankreuzen und auf „Akzeptieren“ klicken."
      },
      "access-denied": {
        "message-1": "Damit Team Today mit <strong>Microsoft 365</strong> funktioniert, benötigen wir die Berechtigung, sicher auf Ihre <strong>Kalender- und E-Mail-Einstellungen</strong> zuzugreifen.",
        "message-2": "Sie können den Zugriff auf team-today.com bei <strong>Ihrer IT-Abteilung</strong> beantragen oder uns unter <a href=\"mailto:hello@team-today.com\">hello@team-today.com</a> für weitere Hilfe kontaktieren."
      },
      "not-access-den-and-not-consent": {
        "message-1": "Etwas Unerwartetes ist passiert.",
        "message-2": "Wir haben das Problem protokolliert. Sie können versuchen, sich erneut anzumelden. Wenn das Problem weiterhin besteht, schreiben Sie uns eine Nachricht an <a href=\"mailto:hello@team-today.com\">hello@team-today.com</a>, und wir melden uns so schnell wie möglich bei Ihnen."
      }
    }
  },
  "login": {
    "title": "Melden Sie sich in Ihrem Konto an",
    "valid-email-address-error": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "enter-password": "Bitte geben Sie ein Passwort ein",
    "signup-with-microsoft": "Sichere Anmeldung mit",
    "sync-own-calendars": "um Ihre Kalender einfach zu synchronisieren.",
    "with-google": "Mit Google anmelden",
    "with-office365": "Mit Microsoft 365 anmelden",
    "or-login-with-email": "Oder mit E-Mail anmelden",
    "email-address": "E-Mail-Adresse",
    "password": "Passwort",
    "repeat-password": "Passwort wiederholen",
    "remember": "Angemeldet bleiben",
    "login": "Anmelden",
    "no-account": "Noch kein Konto?",
    "have-an-account": "Bereits ein Konto?",
    "microsoft": "Microsoft",
    "microsoft-or-google": "Microsoft oder Google",
    "email-sent": "Wir haben Ihnen eine E-Mail gesendet",
    "email-validated": "Ihre E-Mail wurde bestätigt. Melden Sie sich jetzt bei Team Today an, um loszulegen.",
    "email-validation-failed": "Versuchen Sie, die Bestätigungs-E-Mail erneut anzufordern.",
    "terms-link": {
      "1": "Ich stimme den",
      "2": "Nutzungsbedingungen",
      "3": "und der",
      "4": "Datenschutzrichtlinie"
    },
    "marketing-emails": "Halten Sie mich über die neuesten Nachrichten und Inhalte von Team Today auf dem Laufenden",
    "login-failed-with-azure": "Bei der Abfrage Ihres Kontos von Microsoft ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "login-failed-with-azure-help": "Wenn das Problem weiterhin besteht, kontaktieren Sie uns unter <0>hello@team-today.com</0>, und wir helfen Ihnen weiter.",
    "create-account-with-own-password": "Erstellen Sie ein Konto mit Ihrem eigenen Passwort. Dieses Konto wird nicht mit Microsoft 365 oder Google synchronisiert.",
    "company-already-has-account": "Ihr Unternehmen hat bereits ein Konto. Sie können direkt mit Ihrem Microsoft 365-Login fortfahren.",
    "try-another-method": "Oder klicken Sie hier, um eine andere Methode zu verwenden",
    "not-registered": "Das Konto {{email}} ist nicht bei Team Today registriert.",
    "not-registered-no-email": "Ihr Microsoft-Konto ist nicht bei Team Today registriert.",
    "not-registered-help": "Wenn Ihr Unternehmen Team Today bereits nutzt, bitten Sie einen Kollegen oder IT-Administrator um eine Einladung, andernfalls registrieren Sie ein neues Konto.",
    "not-registered-assistance": "Wenn Sie Hilfe benötigen, kontaktieren Sie uns unter <0>hello@team-today.com</0>."
  },
  "register": {
    "title": "Registrieren",
    "best-experience-signup": "Für die beste Erfahrung registrieren Sie sich sicher mit <strong>Microsoft</strong> oder <strong>Google</strong>, um Team Today einfach mit Ihrem Arbeitskalender zu synchronisieren.",
    "office365": "Mit Microsoft 365 registrieren",
    "google": "Mit Google registrieren",
    "email": "Mit E-Mail registrieren",
    "follow-the-link": "Folgen Sie dem Link, um Ihre Registrierung abzuschließen.",
    "review-terms": "Lesen Sie die Bedingungen, um sich zu registrieren",
    "terms-accept-message": "Ich stimme den <0>Nutzungsbedingungen</0> und der <1>Datenschutzrichtlinie</1>* zu",
    "best-experience-use-ms": "Für die beste Erfahrung empfehlen wir die sichere Registrierung mit <strong>Microsoft</strong>, um Team Today einfach mit Ihrem Arbeitskalender zu synchronisieren.",
    "create-account-with-password": "Konto mit Passwort erstellen",
    "register-tnc": "Ich stimme den <a href=\"https://team-today.com/legal/terms-and-conditions\">Nutzungsbedingungen</a> und der <a href=\"https://team-today.com/legal/privacy-policy\">Datenschutzrichtlinie</a>* zu",
    "verification-required": "Wir müssen Ihre E-Mail bestätigen",
    "check-inbox": "Überprüfen Sie Ihren Posteingang",
    "follow-link": "Folgen Sie dem Link, um Ihre Registrierung abzuschließen",
    "resend-email": "E-Mail erneut senden?"
  },
  "teams-register": {
    "title": "Die einfachste Möglichkeit, <strong>hybrides Arbeiten zu verwalten und zu planen</strong>",
    "create-account": "Oder <0>ein Konto mit E-Mail</0> und Passwort erstellen",
    "have-account": "Sie haben bereits ein Konto? <0>Anmelden</0>",
    "list-item-1": "Verwalten Sie <strong>Team-Aufenthaltsorte</strong>",
    "list-item-2": "Buchen Sie <strong>Schreibtische</strong> und verwalten Sie <strong>Büros</strong>",
    "list-item-3": "Planen Sie Urlaub und <strong>Feiertage</strong>",
    "started": "Kostenlos starten",
    "": ""
  },
  "forgot-password": {
    "forgot-password": "Passwort vergessen",
    "description": "Geben Sie Ihre E-Mail-Adresse ein, und wir senden Ihnen einen Link zum Erstellen eines neuen Passworts",
    "send-password": "Passwort zurücksetzen senden",
    "request-processing": "Ihre Anfrage zum Zurücksetzen des Passworts wird bearbeitet.",
    "follow-link": "Folgen Sie dem Link, um Ihr Passwort zurückzusetzen.",
    "enter-email-address": "Geben Sie Ihre E-Mail-Adresse ein, und wir senden Ihnen einen Link zum Erstellen eines neuen Passworts",
    "send-password-reset": "Passwort zurücksetzen senden",
    "your-email-address": "Ihre E-Mail-Adresse"
  },
  "reset-password": {
    "stale-token": "Dieser Token ist abgelaufen. Fordern Sie eine neue E-Mail an",
    "success": "Erfolg! Gehen Sie zur Anmeldeseite, um sich anzumelden",
    "forgot-password": "Passwort vergessen",
    "go-to-login": "Zur Anmeldung gehen",
    "try-requesting-new-email-reset": "Versuchen Sie, eine neue E-Mail zum Zurücksetzen anzufordern",
    "request-new-email-reset": "Neue E-Mail zum Zurücksetzen anfordern",
    "new-pass": "Neues Passwort",
    "repeat-new-pass": "Neues Passwort wiederholen",
    "reset-pass": "Passwort zurücksetzen",
    "reset-pass-to-login": "Setzen Sie Ihr Passwort zurück, um sich anmelden zu können",
    "passwords-not-match": "Passwörter stimmen nicht überein",
    "passwords-not-blank": "Passwort darf nicht leer sein"
  },
  "invite": {
    "title": "Registrierung abschließen",
    "passwords-mismatch": "Passwörter stimmen nicht überein",
    "failed": "Passwörter stimmen nicht überein",
    "register-failed": "Registrierung mit Einladung fehlgeschlagen",
    "tandc": "Bitte akzeptieren Sie die Nutzungsbedingungen, um fortzufahren.",
    "issues": "Haben Sie weiterhin Probleme? Schreiben Sie uns eine E-Mail an <a href=\"mailto:hello@team-today.com\">hello@team-today.com</a>, und wir melden uns so schnell wie möglich bei Ihnen.",
    "create-account-with-password": "Oder <0>ein Konto mit Passwort erstellen</0>"
  },
  "team-view": {
    "team-view": "Team-Ansicht",
    "whereabouts": "Aufenthaltsorte",
    "edit-whereabouts": "Aufenthaltsorte bearbeiten",
    "set-whereabouts": "Aufenthaltsorte festlegen",
    "teams": "Teams",
    "offices": "Büros",
    "workgroup": "Arbeitsgruppe",
    "departments": "Abteilungen",
    "misc": "Sonstiges",
    "whereabouts-report": "Mein Aufenthaltsbericht"
  },
  "settings": {
    "settings": "Einstellungen",
    "bookable-areas": "Buchbare Bereiche",
    "button-add-team-member": "Neues Teammitglied hinzufügen",
    "button-add-user": "Benutzer hinzufügen",
    "edit-office": "Büro bearbeiten",
    "create-new-office": "Neues Büro erstellen",
    "edit-past-whereabouts-title": "Bearbeitung vergangener Aufenthaltsorte blockieren",
    "edit-past-whereabouts-enabled-description": "Diese Einstellung ermöglicht nur Unternehmens- und Büroadmins, Aufenthaltsorte vergangener Wochen zu bearbeiten.",
    "edit-past-whereabouts-disabled-description": "Benutzer können ihre vergangenen Aufenthaltsorte bearbeiten",
    "edit-past-whereabouts-recommendation": "Wir empfehlen, dies zu aktivieren, wenn Genehmigungen aktiviert sind oder Team Today zur Überwachung von Abwesenheiten verwendet wird.",
    "manage-teams-and-users": "Teams und Benutzer verwalten",
    "users-with-no-teams": "Benutzer ohne Team",
    "my-team": "Mein Team",
    "other-teams": "Andere Teams",
    "personal-pref": "Persönliche Einstellungen",
    "personal-pref-desc": "Erinnerungen einstellen und Ihre Team Today-Ereignisse mit Ihrem persönlichen Kalender synchronisieren",
    "email-reminder": "E-Mail-Erinnerung",
    "email-reminder-desc": "Erhalten Sie eine wöchentliche E-Mail-Erinnerung, um Ihre Aufenthaltsorte für die kommende Woche festzulegen.",
    "calendar-link": "Ereignisse zu Ihrem Arbeitskalender hinzufügen",
    "languages": "Sprache ändern",
    "calendar-link-tip": "Für die beste Erfahrung empfehlen wir, diese Einstellung aktiviert zu lassen.",
    "calendar-link-desc": "Fügen Sie Ereignisse wie Feiertage und Aufenthaltsorte von Team Today zu Ihrem <strong>Outlook</strong>- oder <strong>Gmail</strong>-Kalender hinzu, damit Teammitglieder sie sehen können.",
    "marketing-emails": "Marketing-E-Mails zulassen",
    "marketing-emails-desc": "Erhalten Sie E-Mails mit Ankündigungen unserer neuesten Funktionen und deren Nutzung.",
    "teams-test": "Teams-Benachrichtigungen testen",
    "teams-test-desc": "Senden Sie sich eine Nachricht aus der Team Today-App in Microsoft Teams, um zu prüfen, ob Benachrichtigungen bei Ihnen ankommen. Sie können eine pro Stunde senden.",
    "teams-test-button": "Test senden",
    "teams-test-sent": "Gesendet. Sie finden die Nachricht in Ihrem Team Today-Chat in Teams. Die nächste können Sie um {{time}} senden.",
    "teams-test-too-soon": "Sie können einen Test pro Stunde senden. Versuchen Sie es um {{time}} erneut.",
    "teams-test-no-chat": "Team Today kann Ihnen in Teams noch keine Nachrichten senden. Fügen Sie die Team Today-App in Teams hinzu oder, falls Sie sie schon haben, senden Sie ihr eine beliebige Nachricht in ihrem Chat. Versuchen Sie es dann erneut.",
    "teams-test-disabled": "Teams-Benachrichtigungen sind für Ihr Konto ausgeschaltet. Schreiben Sie an support@team-today.com, um sie wieder einzuschalten.",
    "teams-test-failed": "Teams hat die Nachricht nicht angenommen. Versuchen Sie es später erneut.",
    "teams-test-error": "Der Test konnte nicht gesendet werden. Versuchen Sie es erneut.",
    "fav-office": "Ihre bevorzugten Büros",
    "assigned-desk": "Zugewiesen",
    "billing-header": "Abrechnungs- und Planeinstellungen",
    "payment-details": "Zahlungsdetails",
    "cancel-message": "Ihre Zahlungsdetails werden von einem Kundenbetreuer verwaltet. Um sie zu aktualisieren oder zu ändern, kontaktieren Sie uns unter <strong><0>support@team-today.com</0></strong>",
    "account-usage": "Verwalten Sie Ihren Abonnement-Tarif, Lizenzen und Rechnungsinformationen.",
    "users-registered": "Registrierte Benutzer",
    "spaces-left": "Verbleibende Plätze",
    "teams-in-use": "Teams in Nutzung",
    "teams-left": "Verbleibende Teams",
    "member-limit-reached": "Ihr Konto ist jetzt voll",
    "account-full-in-teams": "Dieses Konto ist jetzt voll. Bitte kontaktieren Sie uns unter support@team-today.com",
    "account-full-normal": "Ihr <strong>kostenloses Konto</strong> ist jetzt <strong>voll</strong>. Um weitere Teammitglieder hinzuzufügen, müssen Sie auf ein kostenpflichtiges Konto upgraden.",
    "holiday-rules": "Urlaubsregeln abschließen",
    "holiday-year-start-message": "Teilen Sie uns mit, wann Ihr Urlaubsjahr beginnt.",
    "all-users-have-team": "Alle Benutzer haben ein Team!",
    "setup-a-company": "Richten Sie eine Unternehmensansicht ein, um alle Ihre Teams an einem Ort zu sehen",
    "company-name": "Unternehmensname",
    "create-floor-plan": "Grundriss erstellen",
    "create-floor-plan-description": "Mit einem Grundriss können Sie bestimmte Schreibtische buchen und sehen, wo Teammitglieder sitzen",
    "create-floor-plan-instructions": "Senden Sie Ihren Grundriss an <0 href=\"mailto:hello@team-today.com\">hello@team-today.com</0>, und wir erstellen eine interaktive Version davon für Ihr Team... KOSTENLOS",
    "users-reporting-to-this-user": "Dies sind alle Personen, die direkt diesem Benutzer unterstellt sind.",
    "line-reports": "Direkt unterstellte Mitarbeiter",
    "indirect-line-reports": "Indirekt unterstellte Mitarbeiter",
    "no-line-reports": "Keine unterstellten Mitarbeiter",
    "office-management": "Büroverwaltung",
    "set-limits-on-offices": "Setzen Sie eine Grenze für die Anzahl der verfügbaren Büroschreibtische, damit Kollegen wissen, wann sie ins Büro kommen können.",
    "offices": "Büros",
    "office-floor": "Büroetage",
    "manage-office-locations-title": "Bürostandorte verwalten",
    "manage-office-locations-description": "Erstellen und verwalten Sie mehrere Büros im Bereich Büroverwaltung.",
    "assign-users": "Benutzer zuweisen",
    "users-not-in-team": "Diese Benutzer sind derzeit in keinem Team. Tippen Sie auf einen, um ihn einem Team zuzuweisen.",
    "locked-signup-domains": {
      "title": "Gesperrte Domains",
      "subtitle": "Verhindern Sie, dass Personen aus Ihrem Unternehmen ein separates Team Today-Konto anlegen. Wer sich mit einer dieser Domains registriert, erfährt, dass Ihr Unternehmen bereits ein Konto hat, und soll einen Kollegen um eine Einladung bitten. Eingeladene Nutzer können weiterhin wie gewohnt beitreten.",
      "approval-note": "Neue Domains werden vom Team Today-Team geprüft, bevor sie wirksam werden. Das dauert in der Regel einen Werktag.",
      "placeholder": "z. B. ihrunternehmen.de",
      "add": "Domain hinzufügen",
      "remove": "Entfernen",
      "empty": "Noch keine Domains hinzugefügt.",
      "status-active": "Aktiv",
      "status-pending": "Genehmigung ausstehend",
      "status-rejected": "Nicht genehmigt",
      "rejected-help": "Wir konnten nicht bestätigen, dass Ihr Unternehmen diese Domain besitzt. Wenden Sie sich an support@team-today.com, wenn Sie glauben, dass dies ein Fehler ist.",
      "remove-confirm": "{{domain}} entfernen? Personen mit dieser E-Mail-Domain können dann wieder ein neues Konto anlegen.",
      "add-failed": "Diese Domain konnte nicht hinzugefügt werden.",
      "remove-failed": "Diese Domain konnte nicht entfernt werden."
    },
    "domain-based-signup": {
      "title": "Domainnamen verknüpfen",
      "subtitle": "Einzelne Personen können sich selbst registrieren",
      "everyone": "Gut für alle",
      "enabled-message": "Jeder, der sich mit einer E-Mail-Adresse registriert, die auf <0>{{domainName}}</0> endet, wird sofort Ihrem Konto hinzugefügt. Teilen Sie ihnen einfach Team Today mit und bitten Sie sie, ein Konto zu erstellen.",
      "enabled-message-multiple": "Jeder, der sich mit einer E-Mail-Adresse registriert, die auf eine der Domains <0>{{domains}}</0> endet, wird sofort Ihrem Konto hinzugefügt. Teilen Sie ihnen einfach Team Today mit und bitten Sie sie, ein Konto zu erstellen.",
      "disabled-message": "Jeder, der sich mit einer E-Mail-Adresse registriert, die auf <0>Ihren Domainnamen</0> endet, wird sofort Ihrem Konto hinzugefügt. Teilen Sie ihnen einfach Team Today mit und bitten Sie sie, ein Konto zu erstellen.",
      "your-domain-name": "Ihren Domainnamen",
      "domains-title": "Verknüpfte Domains",
      "approval-note": "Fügen Sie alle E-Mail-Domains hinzu, die Ihr Unternehmen verwendet. Jede wird vom Team Today-Team geprüft, bevor sie wirksam wird, in der Regel innerhalb eines Werktags.",
      "placeholder": "z. B. ihrunternehmen.de",
      "add": "Domain hinzufügen",
      "remove": "Entfernen",
      "empty": "Noch keine Domains verknüpft. Fügen Sie die E-Mail-Domain Ihres Unternehmens hinzu, um zu beginnen.",
      "status-active": "Aktiv",
      "status-pending": "Genehmigung ausstehend",
      "status-rejected": "Nicht genehmigt",
      "rejected-help": "Wir konnten nicht bestätigen, dass Ihr Unternehmen diese Domain besitzt. Kontaktieren Sie support@team-today.com, wenn Sie das für einen Fehler halten.",
      "remove-confirm": "{{domain}} entfernen? Personen mit dieser E-Mail-Domain treten Ihrem Konto dann nicht mehr automatisch bei.",
      "add-failed": "Diese Domain konnte nicht hinzugefügt werden.",
      "remove-failed": "Diese Domain konnte nicht entfernt werden.",
      "switch-off-note": "Schalten Sie den Schalter oben ein, damit diese Domains wirksam werden.",
      "pending-line-1": "Bitte erlauben Sie 24 Stunden für diese Einstellung",
      "pending-line-2": "Als Teil unseres Sicherheitsprozesses überprüfen wir Verknüpfungsanfragen aktiv.",
      "pending-line-3": "Nach der Genehmigung müssen neue Benutzer, die nicht eingeladen wurden, einem Team zugewiesen werden. Sie können dies in den Benutzereinstellungen tun.",
      "pending-line-4": "Sie können weiterhin direkte Einladungen an E-Mail-Adressen senden, die nicht auf diesen Domainnamen enden.",
      "active-line-1": "Nur zur Information",
      "active-line-2": "Neue Benutzer, die nicht eingeladen wurden, müssen einem Team zugewiesen werden. Sie können dies in den Benutzereinstellungen tun.",
      "active-line-3": "Sie können weiterhin direkte Einladungen an E-Mail-Adressen senden, die nicht auf diesen Domainnamen enden."
    },
    "private-groups": {
      "title": "Sichtbarkeit aller Gruppen einschränken",
      "subtitle": "Die Sichtbarkeit aller Abteilungen, Teams und Gruppen ist eingeschränkt. Nur Unternehmens- und Büroadmins sowie Benutzer in den Gruppen können die Aufenthaltsorte anderer Benutzer einsehen."
    },
    "restrict-team-management": {
      "title": "Teamverwaltung einschränken",
      "subtitle": "Beschränken Sie die Verwaltung von Teams auf Unternehmensadmins. Dies umfasst das Hinzufügen neuer Benutzer sowie das Verschieben oder Entfernen bestehender Benutzer."
    },
    "show-birthdays": {
      "title": "Geburtstage anzeigen",
      "subtitle": "Wenn ein Benutzer Monat und Tag seines Geburtstags festgelegt hat, werden die Geburtstage der Benutzer als kleines Symbol auf ihren Aufenthaltsorten angezeigt."
    },
    "azure-scim": {
      "medium": "Mittel - Große Unternehmen (50+)",
      "title": "Microsoft Azure und Team Today",
      "subtitle": "Benutzer aus dem Active Directory in Team Today importieren",
      "description": "IT-Admins können Team Today im Microsoft Azure Marketplace nachschlagen. Dies automatisiert das Hinzufügen und Entfernen von Benutzern in Team Today aus dem Active Directory und ordnet sie Teams, Arbeitsgruppen oder Abteilungen zu. Detaillierte Anweisungen finden Sie auf unseren Support-Seiten.",
      "line-1": "Nur zur Information",
      "line-2": "Wenn dies aktiviert ist, erhalten neu bereitgestellte Benutzer eine Willkommens-E-Mail und werden jede Woche daran erinnert, ihre Aufenthaltsorte festzulegen.",
      "line-3": "Weitere Informationen zur Konfiguration finden Sie unter <0 href=\"https://www.team-today.com\">SCIM-Konfiguration</0>",
      "enabled-departments": "Benutzer in Abteilungen bereitstellen",
      "enabled-departments-description": "Benutzer bereitstellen und ihre Abteilung basierend auf ihrem Azure AD-Abteilungsattribut aktualisieren.",
      "disable-welcome-email": "Willkommens-E-Mail an neu bereitgestellte Benutzer senden",
      "disable-welcome-email-description": "Nach Abschluss der anfänglichen Azure-Einrichtung und -Tests empfehlen wir, diese Einstellung zu aktivieren, um Willkommens-E-Mails an neue Benutzer zu senden.",
      "disable-new-user-access": "Neu bereitgestellten Benutzern Zugriff auf Team Today gewähren",
      "disable-new-user-access-description": "Nach Abschluss der anfänglichen Azure-Einrichtung und -Tests empfehlen wir, diese Einstellung zu aktivieren, um neuen Benutzern Zugriff auf Team Today zu gewähren.",
      "scim-integration": "SCIM-Integrationseinstellungen",
      "scim-endpoint": "SCIM-Endpunkt",
      "scim-endpoint-description": "Geben Sie dies bei der Einrichtung der Bereitstellung in Microsoft Entra ID als Mandanten-URL (Tenant URL) ein und verwenden Sie einen SCIM-API-Schlüssel als geheimes Token (Secret Token).",
      "enabled-departments-description-2": "Die Aktivierung verhindert, dass Abteilungen in Team Today verwaltet werden, da Aktualisierungen über SCIM erfolgen."
    },
    "spreadsheet": {
      "trial": "Unternehmen in einer kostenlosen Testphase",
      "title": "Tabelle importieren",
      "subtitle": "Wenn Sie Azure noch nicht verbinden möchten oder weniger als 50 Mitarbeiter haben",
      "description": "Kontaktieren Sie support@team-today.com, und wir senden Ihnen eine Vorlage zum Ausfüllen, die Sie zurücksenden, und wir erledigen den Rest."
    },
    "holiday-approval": {
      "title": "Genehmigungsbenachrichtigungen",
      "message": "Dies sendet den relevanten Vorgesetzten eine E-Mail, wenn ein Urlaub gebucht wird, und fordert sie auf, in Team Today eine Urlaubsanfrage zu überprüfen."
    },
    "holiday-tracking": {
      "title": "Urlaubsverfolgung aktivieren",
      "message": "Dies aktiviert die Urlaubsverfolgungseinstellung, damit Kollegen schnell sehen können, wann Personen in ihrem Team und anderen Urlaub geplant haben."
    },
    "line-management": {
      "title": "Vorgesetztenfunktion aktivieren",
      "enabled-message": "Dies ermöglicht Ihnen, unterstellte Mitarbeiter Benutzern zuzuweisen. Diese Vorgesetzten können Anfragen ihrer unterstellten Mitarbeiter genehmigen. Gehen Sie zu <0 to={\"/manage/users?view=user\"}>Benutzeransicht</0>, um nach Benutzern zu suchen und ihnen unterstellte Mitarbeiter zuzuweisen.",
      "disabled-message": "Dies aktiviert die Vorgesetztenfunktion, damit Sie unterstellte Mitarbeiter Benutzern zuweisen können. Diese Vorgesetzten können Anfragen ihrer unterstellten Mitarbeiter genehmigen."
    },
    "seven-day": {
      "title": "Sieben-Tage-Woche aktivieren",
      "enabled-message": "Dies ermöglicht Benutzern, Aufenthaltsorte an Wochenenden festzulegen.",
      "disabled-message": "Dies ermöglicht Benutzern, Aufenthaltsorte an Wochenenden festzulegen."
    },
    "weekly-notes": {
      "title": "Wöchentliche Notizen aktivieren",
      "enabled-message": "Wöchentliche Notizen aktiviert, Benutzer können dies auf der Team-Aufenthaltsortseite festlegen.",
      "disabled-message": "Dies aktiviert wöchentliche Notizen - ein Freitextfeld, das Benutzer mit einer kurzen Beschreibung ausfüllen können, die Kollegen über ihre Woche sehen können."
    },
    "global-email-setting": {
      "title": "E-Mail-Erinnerungen zum Festlegen von Aufenthaltsorten",
      "all-users": "Erinnerungen werden wöchentlich an alle Benutzer gesendet, wenn unvollständig",
      "no-users": "Keine Erinnerungen senden",
      "users-choice": "Einzelpersonen erlauben, ihre eigenen Erinnerungen zu steuern",
      "description": "Wählen Sie, wie Erinnerungen gesendet werden. Erinnerungen werden gesendet, wenn ein Benutzer die Aufenthaltsorte für die kommende Woche nicht festgelegt hat."
    },
    "icon-pack": {
      "title": "Team Today-Ikonografie",
      "description": "Sie können das Aussehen und den Stil der in Team Today verwendeten Symbole ändern",
      "standard": "Standard",
      "basic": "Professionell"
    },
    "tenant-based": {
      "title": "Mandantenbasierte Registrierung",
      "message-1": "Dies verknüpft Ihre Microsoft-Mandanten-ID mit diesem Konto. Jeder, der sich registriert, wird automatisch diesem Konto hinzugefügt.",
      "message-2": "Sie können weiterhin manuell Personen außerhalb Ihres Microsoft-Kontos einladen, sich Ihnen anzuschließen.",
      "active-1": "Nur zur Information",
      "active-2": "Neue Benutzer, die nicht eingeladen wurden, müssen einem Team zugewiesen werden. Sie können dies in den Benutzereinstellungen tun.",
      "active-3": "Sie können weiterhin direkte Einladungen an E-Mail-Adressen senden, die nicht auf diesen Domainnamen enden."
    },
    "hot-desking-page": {
      "title": "Erweiterte Schreibtischbuchung",
      "message-1": "Als Teil eines kostenpflichtigen Plans können Sie",
      "message-2": "Mehrere Büros erstellen",
      "message-3": "Etagen und Bürobereiche für Teams zum Buchen erstellen",
      "message-4": "Alles mit Ihrem Outlook- oder Gmail-Kalender verknüpfen",
      "button": "Erweiterte Schreibtischbuchung aktivieren"
    },
    "editing-future-whereabouts": {
      "repeat-weekly-schedule": "Aufenthaltsortpläne",
      "repeat-weekly-schedule-description": "Wie viele Wochen im Voraus kann ein Benutzer seine Aufenthaltsorte automatisch festlegen. Wir empfehlen 52 Wochen.",
      "schedules": "Benutzern erlauben, die nächsten Wochen Aufenthaltsorte automatisch gleichzeitig festzulegen",
      "number-of-weeks": "Vorausplanungslimit (in Wochen)",
      "applies-to-team-admins": "Gilt für Team-Admins",
      "applies-to-standard-users": "Gilt für Standardbenutzer",
      "number-of-weeks-description": "Die Anzahl der Wochen, die Benutzer im Voraus Aufenthaltsorte festlegen können"
    },
    "approvals": {
      "title": "Genehmigungen",
      "do-holidays-require-approval": "Müssen Urlaube von einem Vorgesetzten oder Unternehmensadmin genehmigt werden?",
      "how-it-works": "So funktioniert es",
      "create-line-managers-message-1": "Erstellen Sie Vorgesetzte, indem Sie direkte Mitarbeiter für jeden Benutzer auf der Einstellungsseite der Person hinzufügen. (Tippen Sie auf den Benutzer, den Sie bearbeiten möchten)",
      "create-line-managers-message-2": "Wenn Mitarbeiter Urlaub oder Ferien buchen, wird der Vorgesetzte aufgefordert, die Anfrage zu genehmigen.",
      "create-line-managers-message-3": "Unternehmensadmins können alle Anfragen genehmigen.",
      "please-note": "Bitte beachten Sie",
      "please-note-message-1": "Derzeit können nur <strong>Unternehmensadmins</strong> Urlaubsanfragen genehmigen oder ablehnen.",
      "company-admins": "Unternehmensadmins",
      "please-note-message-2": "Vorgesetzte können dies auch tun, aber Sie müssen die Einstellung 'Vorgesetzte' auf der Unternehmenseinstellungsseite aktivieren und dann jedem Benutzer unterstellte Mitarbeiter zuweisen.",
      "approvals-disabled-title": "Urlaubsgenehmigungen inaktiv",
      "approvals-disabled-description": "Sie können Urlaubsgenehmigungen für Vorgesetzte im Hauptbereich der Einstellungen aktivieren."
    },
    "holiday-allowance": {
      "title": "Urlaubsanspruch",
      "message-1": "Legen Sie eine Grenze fest, wie viele Tage jede Person freinehmen kann.",
      "please-note": "Bitte beachten Sie",
      "message-2": "Benutzer haben alle {{defaultHolidayCount}} Urlaubstage, bis sie von einem Unternehmensadmin oder Vorgesetzten auf der Einstellungsseite jedes Benutzers festgelegt werden.",
      "zero": "Null",
      "edit-individual-allowances": "Individuelle Urlaubsansprüche bearbeiten"
    },
    "holiday-setting": {
      "year": "Urlaubsjahr",
      "month": "Der Zeitraum des Jahres, in dem Ihr Urlaubszeitraum beginnt und endet."
    },
    "manage-area": {
      "create-area": "Buchbaren Bereich erstellen",
      "name": "Bereichsname",
      "message-1": "Dies erstellt Bereiche, die mehrere Benutzer buchen können.",
      "message-2": "Macht die Schreibtischbuchung schneller",
      "number-of-desks": "Anzahl der Schreibtische"
    },
    "manage-desk": {
      "create-desk": "Einzelne buchbare Schreibtische erstellen",
      "message-1": "Am besten für Personen geeignet, die immer am selben Schreibtisch sitzen",
      "message-2": "",
      "number-of-desks": "Anzahl der Schreibtische",
      "floor-plans-enabled": "Sie haben scheinbar interaktive Grundrisse aktiviert",
      "contact-us-to-change": "Sie können immer noch einen neuen Schreibtisch zur Etage hinzufügen, aber kontaktieren Sie uns unter <0 href=\"mailto:hello@team-today.com\">hello@team-today.com</0>, um ihn dem interaktiven Grundriss hinzuzufügen.",
      "desk-name": "Schreibtischname"
    },
    "visitor-booking": {
      "title": "Besucherbuchung aktivieren (Beta)",
      "heading": "Besucherverwaltung",
      "upsell": "Besucherbuchung ist in den Tarifen Premium und Enterprise verfügbar.",
      "upsell-link": "Tarif upgraden",
      "not-enabled": "Diese Funktion ist für Ihr Konto nicht aktiviert. Kontaktieren Sie"
    },
    "manage-office": {
      "title": "Büroetage erstellen?",
      "message": "Teilen Sie Ihr Büro in Etagen auf, um Ihren Kollegen zu helfen, zu wissen, wo sie sitzen sollen",
      "another-floor": "Weitere Etage hinzufügen",
      "additional-access-required": "Zusätzlicher Zugriff erforderlich",
      "company-admin-only": "Nur ein Unternehmensadmin kann neue Büros/Etagen/Bereiche/Schreibtische erstellen",
      "nosetup": "Sie haben noch nichts eingerichtet, beginnen Sie mit dem Hinzufügen eines Büros.",
      "no-setup-message-1": "Erstellen Sie <strong>Etagen</strong> und <strong>Bürobereiche</strong> für Teams zum Buchen",
      "no-setup-message-2": "Erstellen Sie mehrere Büros",
      "no-setup-message-3": "Verknüpfen Sie alles mit Ihrem <strong>Outlook</strong>- oder <strong>Gmail-Kalender</strong>",
      "enable-car-parking": "Parkplatzbuchung aktivieren",
      "car-parking-capacity": "Anzahl der Parkplätze",
      "desk-booking-window-title": "Schreibtischbuchungsfenster aktivieren",
      "desk-booking-window-description": "Verhindern Sie, dass Benutzer Schreibtische zu weit im Voraus blockieren",
      "desk-booking-window-weeks": "Anzahl der Wochen, die Benutzer im Voraus buchen können",
      "desk-booking-window-opens-description": "Legen Sie fest, wann die nächste Buchungswoche freigegeben wird. Die ganze Woche wird zu diesem Zeitpunkt freigegeben.",
      "desk-booking-window-open-day": "Freigabe am",
      "desk-booking-window-open-time": "Freigabe um",
      "desk-booking-window-timezone": "Zeitzone",
      "desk-booking-window-unit": "Zeitraum zählen in",
      "desk-booking-window-unit-weeks": "Wochen",
      "desk-booking-window-unit-days": "Tage",
      "desk-booking-window-unit-workdays": "Arbeitstage (Mo bis Fr)",
      "desk-booking-window-days": "Anzahl der Tage, die Benutzer im Voraus buchen können",
      "desk-booking-window-workdays": "Anzahl der Arbeitstage, die Benutzer im Voraus buchen können",
      "desk-booking-window-opens-daily-description": "Legen Sie die Uhrzeit fest, zu der jeden Tag der nächste Tag freigegeben wird.",
      "desk-booking-window-max-days": "Das Buchungsfenster darf höchstens {{max}} Tage betragen"
    },
    "meeting-rooms": {
      "manage-meeting-rooms": "Besprechungsräume verwalten",
      "add-meeting-rooms": "Besprechungsräume hinzufügen",
      "create": "Besprechungsraum hinzufügen",
      "name": "Besprechungsraumname",
      "meeting-room-email-address": "Outlook-Besprechungsraum-E-Mail-Adresse",
      "important": "Wichtig",
      "important-message": "Benutzer müssen ihre Kalendersynchronisation aktiviert haben, damit Räume in Outlook sowie in Team Today reserviert werden können. Dieser Status wird in der Team-Ansicht als grün angezeigt.",
      "capacity": "Kapazität",
      "office": "Büro",
      "floor": "Etage",
      "edit": "Besprechungsraum bearbeiten",
      "limit-title": "Besprechungsraumlimit erreicht",
      "limit-description": "Kontaktieren Sie uns unter <0 href=\"mailto:support@team-today.com\">support@team-today.com</0>, um Ihr Limit zu erhöhen",
      "microsoft-link": "Diesen Raum mit einem Besprechungsraum in Outlook verknüpfen",
      "microsoft-link-description": "Sie können den Raum mit einem Raum in Outlook verknüpfen, indem Sie die E-Mail-Adresse des Raums verwenden. Dies erfordert, dass Benutzer Kalenderberechtigungen aktiviert haben, damit der Raum in Outlook sowie in Team Today reserviert werden kann.",
      "introduction": {
        "how": "So funktioniert es",
        "intro": "Fügen Sie einen Besprechungsraum in Team Today statt in Outlook oder Google hinzu, um Folgendes zu ermöglichen:",
        "intro-1": "Teammitglieder können alle Besprechungsräume an einem Ort leicht finden",
        "intro-2": "Schnell Verfügbarkeit prüfen und Räume buchen",
        "intro-3": "Besprechungsräume auf einem interaktiven Grundriss buchen (wenn ein Grundriss hinzugefügt wurde)"
      },
      "meeting-room": "Besprechungsraum"
    },
    "looking-after-multiple-teams": "Verwalten Sie mehrere Teams?",
    "create-a-company": "Erstellen Sie eine Unternehmensansicht, um alle Ihre Teams an einem Ort zu sehen",
    "departments": {
      "title": "Abteilungen verwalten",
      "add-new": "Neue Abteilung hinzufügen",
      "add-members": "Neue Mitglieder hinzufügen"
    },
    "desk-booking": "Schreibtischbuchung",
    "office-information": "Büroinformationen",
    "office-information-how-it-works": "Büros werden den Benutzern zur Buchung in Team Whereabouts angezeigt. Sie können Benutzer einem Büro zuweisen, sodass dies ihr Standardstandort ist.",
    "desk-bookings-how-it-works": "Büros werden den Benutzern zur Buchung in Team Whereabouts angezeigt. Sie können Benutzer einem Büro zuweisen, sodass dies ihr Standardstandort ist.",
    "car-parking": "Parkplatz",
    "car-parking-how-it-works": "Büroparkplatz, kontaktieren Sie uns, um Parkplätze mit einer interaktiven Karte zu verwalten.",
    "automatic-checkin": "Automatischer Check-in",
    "schengen": {
      "title": "Schengen-Erfassung",
      "subtitle": "Erfassen Sie die Anzahl der Tage, die Personen im Schengen-Raum verbringen"
    },
    "whereabouts-reminder-config": {
      "title": "Erinnerungseinstellungen für Aufenthaltsorte",
      "subtitle": "Senden Sie wöchentliche Erinnerungen an Benutzer in Microsoft Teams, um ihre Aufenthaltsorte festzulegen.",
      "day": "Tag für Erinnerung",
      "day-placeholder": "Tag zum Senden",
      "hour": "Uhrzeit für Erinnerung",
      "hour-placeholder": "Uhrzeit zum Senden",
      "timezone": "Zeitzone",
      "timezone-placeholder": "Zeitzone",
      "enable": "Aktivieren"
    },
    "carry-over": {
      "title": "Automatischen Übertrag aktivieren",
      "description": "Überträgt automatisch Urlaub aus dem Vorjahr",
      "carry-over-days": "Maximaler Übertrag",
      "rules-title": "Verfallsregeln hinzufügen",
      "rules-description": "Legen Sie eine Regel fest, damit übertragene Tage vor einem bestimmten Datum verwendet werden",
      "expires-on": "Übertrag verfällt am"
    },
    "manage-hospitality": {
      "title": "Bewirtung verwalten",
      "enable-hospitality": "Bewirtung aktivieren",
      "add-new-item": "Bewirtungsartikel hinzufügen",
      "add-people-to-notify": "Personen zur Benachrichtigung hinzufügen",
      "important-note": "Kein wichtiger Hinweis festgelegt",
      "important-note-title": "Wichtige Bewirtungshinweise (sichtbar für Mitarbeiter)",
      "notifications": "Benachrichtigungen",
      "add-people-message": "Fügen Sie Personen hinzu (z.B. Büroassistenten), die benachrichtigt werden, wenn eine Bewirtungsanfrage eingereicht wird.",
      "number-of-people-notifying": "{{count}} Personen werden benachrichtigt.",
      "hospitality-description": "Fügen Sie Artikel hinzu (z.B. Catering), die Mitarbeiter für Besprechungsräume anfordern können.",
      "menu-item": "Menüartikel",
      "availability": "Verfügbarkeit",
      "item-name": "Artikelname",
      "notes": "Notizen",
      "price": "Preis",
      "currency": "Währung",
      "add-hospitality-item": "Bewirtungsartikel hinzufügen",
      "edit-important-note": "Wichtigen Hinweis bearbeiten"
    },
    "notify-manager-on-leave-cancellation": {
      "title": "Cancellation notifications",
      "subtitle": "When enabled, a user's line manager is emailed when the user cancels their own approved leave (holiday or any approval-required leave type)."
    }
  },
  "edit-workgroup": {
    "edit-workgroup": "Arbeitsgruppe verwalten",
    "edit-workgroup-name": "Arbeitsgruppennamen bearbeiten",
    "add-or-remove-members": "Mitglieder hinzufügen oder entfernen",
    "add-users-to-group": "Benutzer zur Gruppe hinzufügen",
    "select-users-to-add": "Benutzer zum Hinzufügen auswählen"
  },
  "week-notes": {
    "week-notes": "Wochennotizen",
    "must-be-in-team": "Du musst Teil eines Teams sein, um eine Wochennotiz festzulegen",
    "save-failed": "Speichern der Wochennotiz fehlgeschlagen. Bitte versuche es erneut."
  },
  "personal-perf": {
    "personal-perf": "Persönliche Einstellungen",
    "office-perf": "Büroeinstellungen",
    "other-perf": "Andere Einstellungen",
    "default-office-and-location": "Standardbüro und -ort",
    "default-office-title": "Ihr Standardbüro und -ort",
    "default-office-description": "Die Festlegung eines Standardbüros macht das Festlegen von Aufenthaltsorten schneller. Sie können immer noch jedes andere Büro auswählen, das Sie besuchen möchten.",
    "require-space-title": "Parkplatz erforderlich",
    "require-space-description": "Aktivieren Sie diese Einstellung, wenn Sie regelmäßig einen Parkplatz benötigen, wenn Sie das Büro besuchen",
    "veh-registration": "Fahrzeugkennzeichen",
    "veh-colour": "Fahrzeugfarbe",
    "veh-make": "Fahrzeugmarke",
    "office-tab": "Büro",
    "notifications-tab": "Benachrichtigungen",
    "calendar-tab": "Kalendersynchronisierung",
    "birthday-tab": "Geburtstag",
    "language-tab": "Sprache"
  },
  "approvals": {
    "approvals-title": "Genehmigungen",
    "approved": "Genehmigt",
    "cancelled": "Storniert",
    "days": "Tage",
    "declined": "Abgelehnt",
    "holiday-approvals": "Genehmigungen",
    "no-results-found": "Keine Ergebnisse gefunden",
    "no-approvals-found": "Keine Genehmigungen gefunden"
  },
  "work-planner": {
    "work-planner": "Arbeitsplaner",
    "show-other-teams": "Andere Teams anzeigen",
    "events-and-projects": "Projekte / Ereignisse",
    "add-event-project": "Projekt / Ereignis hinzufügen",
    "create-event-title": "Geben Sie Ihrem Projekt / Ereignis einen Titel",
    "event-is-for": "Ereignis / Projekt ist für",
    "select-teams-to-follow": "Teams zum Verfolgen auswählen",
    "select-teams-to-follow-description": "Sie können drei Teams zusätzlich zu Ihrem eigenen verfolgen.",
    "select-teams-to-follow-error": "Sie müssen zuerst ein Team entfolgen, bevor Sie einem anderen folgen können."
  },
  "textinput": {
    "from": "Von",
    "date": "Datum",
    "to": "Bis",
    "firstname": "Vorname",
    "lastname": "Nachname",
    "office-location": "Bürostandort (optional)",
    "jobTitle": "Berufsbezeichnung",
    "email": "E-Mail",
    "password": "Passwort",
    "repeat-password": "Passwort wiederholen",
    "office-name": "Büroname",
    "office-postcode": "Büro-Postleitzahl",
    "desks-available": "Schreibtische verfügbar",
    "number-desks-available": "Anzahl der verfügbaren Schreibtische",
    "number-desks-for-floor": "Anzahl der Schreibtische für die Etage festlegen",
    "desks-available-each-day": "Schreibtische täglich verfügbar",
    "floor-name": "Etagenname",
    "add-individual-desks": "Einzelne Schreibtische hinzufügen",
    "areas-names-and-avail": "Bereichsnamen und Verfügbarkeit",
    "desk-names-and-avail": "Schreibtischnamen und Verfügbarkeit",
    "search-existing-user": "Nach einem vorhandenen Benutzer suchen",
    "whereabouts-name": "Aufenthaltsortsname",
    "holiday-title-or-reason": "Urlaubstitel oder Grund",
    "company-settings": "Unternehmensname",
    "team-name": "Teamname",
    "enable-desk-booking": "Schreibtischbuchung aktivieren",
    "enable-car-parking": "Parkplatzbuchung aktivieren",
    "add-date": "Datum hinzufügen",
    "select-placeholder": "Auswählen...",
    "search": "Suchen",
    "select-start-day": "Starttag auswählen",
    "find-user": "Benutzer finden",
    "mac-address-placeholder": "z.B. AA:BB:CC:DD:EE:FF",
    "network-name-placeholder": "z.B. Büro-WLAN",
    "ip-address-placeholder": "z.B. 203.0.113.10",
    "select-desk": "Schreibtisch auswählen",
    "none-available": "Keine verfügbar",
    "select-month": "Monat auswählen",
    "choose-an-office": "Büro auswählen",
    "filter-users": "Benutzer filtern",
    "please-select": "Bitte auswählen",
    "select-team": "Team auswählen",
    "office-three-letter-code": "Büro-Dreibuchstabencode"
  },
  "button": {
    "filters": "Filter",
    "setup-offices": "Büros einrichten",
    "change-office": "Büro ändern",
    "choose-day": "Tag auswählen",
    "save-changes": "Änderungen speichern",
    "back-and-change": "Zurückgehen und ändern",
    "view-whereabouts-report": "Meine Anwesenheitsübersicht anzeigen",
    "continue": "Weiter",
    "done": "Fertig",
    "update": "Aktualisieren",
    "edit": "Bearbeiten",
    "reset-to-current-week": "Auf aktuelle Woche zurücksetzen",
    "view-floor-plan": "Grundriss anzeigen",
    "your-holidays": "Urlaubsplaner",
    "requests": "Genehmigungen",
    "team-holidays": "Teamurlaube",
    "approvals-required": "Genehmigungen erforderlich",
    "view-approvals": "Genehmigungen",
    "team-view": "Team-Ansicht",
    "back-to-team-view": "Zurück zur Team-Ansicht",
    "settings": "Einstellungen",
    "company-view": "Unternehmensansicht",
    "my-requests": "Meine Anfragen",
    "work-planner": "Arbeitsplaner",
    "my-holiday-requests": "Meine Urlaubsanfragen",
    "holiday-requests": "Urlaubsanfragen",
    "office-view": "Büroansicht",
    "all-teams": "Alle Teams",
    "floor-plan": "Grundriss",
    "create-new-work-group": "Neue Arbeitsgruppe erstellen",
    "create-new-team": "Neues Team erstellen",
    "create-new-group": "Neue Gruppe erstellen",
    "create-new-department": "Neue Abteilung erstellen",
    "link-team-or-workgroup": "Team oder Gruppe mit Büro verknüpfen",
    "finish-setting-up-your-account": "Kontoeinrichtung abschließen",
    "filter-by-office": "Teams und Arbeitsgruppen nach Büro filtern",
    "save-whereabouts": "Aufenthaltsorte speichern",
    "clear-day": "Tag löschen",
    "add-holiday-request": "Urlaub hinzufügen",
    "add-holiday": "Urlaub hinzufügen",
    "am": "Vormittags",
    "pm": "Nachmittags",
    "all-day": "Ganztägig",
    "book-holiday": "Urlaub buchen",
    "delete-holiday-request": "Urlaubsanfrage löschen",
    "book-am": "Vormittags buchen",
    "book-pm": "Nachmittags buchen",
    "book-all-day": "Ganztägig buchen",
    "am-only": "Nur Vormittags",
    "pm-only": "Nur Nachmittags",
    "login-to-your-account": "Melden Sie sich in Ihrem Konto an",
    "continue-to-signup": "Weiter zur Registrierung",
    "user-view": "Benutzeransicht",
    "tag-manager": "Arbeitsgruppenmanager",
    "edit-and-manage-team": "Team bearbeiten und verwalten",
    "edit-and-manage-workgroup": "Arbeitsgruppe bearbeiten und verwalten",
    "edit-and-manage-department": "Abteilung bearbeiten und verwalten",
    "add-another-team": "Weiteres Team hinzufügen",
    "add-another-team-member": "Weiteres Teammitglied hinzufügen",
    "set-up-company-and-add-teams": "Unternehmen einrichten und Teams hinzufügen",
    "add-new-favourite": "Neuen Favoriten hinzufügen",
    "logout": "Abmelden",
    "move-another-user": "Weiteres Teammitglied hinzufügen",
    "done-for-now": "Für jetzt fertig",
    "add-to-team": "Zum Team hinzufügen",
    "approve": "Genehmigen",
    "decline": "Ablehnen",
    "approved": "Genehmigt",
    "declined": "Abgelehnt",
    "pending": "Ausstehend",
    "add-new-tag": "Neue Arbeitsgruppe hinzufügen",
    "edit-tags": "Arbeitsgruppen bearbeiten",
    "setup-multiple-offices": "Mehrere Büros einrichten",
    "delete-office": "Büro löschen",
    "add-new-desk": "Neuen Schreibtisch hinzufügen",
    "add-new-area": "Neuen Bereich hinzufügen",
    "send-invite": "Einladung senden",
    "add-team-member": "Teammitglied hinzufügen",
    "delete-team": "Team löschen?",
    "download-csv": ".csv herunterladen",
    "download-excel": "Nach Excel exportieren",
    "send-reminder": "Erinnerung senden",
    "retry": "Erneut versuchen",
    "go-back": "Zurück",
    "finish-and-save": "Fertigstellen und speichern",
    "add-members": "Mitglieder hinzufügen",
    "close": "Schließen",
    "add-team-members": "Teammitglieder hinzufügen",
    "add-later": "Ich mache das später",
    "upgrade": "Mein Konto upgraden",
    "create": "Erstellen",
    "checkout": "Zur Kasse",
    "monthly": "Monatlich",
    "yearly": "Jährlich",
    "confirm": "Bestätigen",
    "save": "Speichern",
    "confirm-delete-team": "Ja, Team löschen",
    "reject-delete-team": "Nein, Team nicht löschen",
    "create-company": "Unternehmen erstellen",
    "setup-more-teams": "Weitere Teams einrichten",
    "ok": "OK",
    "fetch-users-from-microsoft": "Benutzer von Microsoft abrufen",
    "add-company-holiday": "Unternehmensurlaub hinzufügen",
    "got-it": "Verstanden",
    "confirm-delete-user": "Ja, Benutzer löschen",
    "reject-delete-user": "Nein, Benutzer nicht löschen",
    "lets-go": "Los geht's",
    "create-office": "Büro erstellen",
    "EDIT": "BEARBEITEN",
    "add-another-holiday": "Weiteren Urlaub hinzufügen",
    "upgrade-my-account": "Mein Konto upgraden",
    "view-report": "Bericht anzeigen",
    "yes-delete": "Ja, löschen.",
    "cancel": "Abbrechen",
    "delete-user": "Benutzer löschen",
    "change": "Ändern",
    "edit-office": "Büro bearbeiten",
    "create-new-office": "Neues Büro erstellen",
    "add-bookable-area": "Buchbaren Bereich hinzufügen",
    "add-new-line-report": "Neuen unterstellten Mitarbeiter hinzufügen",
    "assign-users-to-team": "Benutzer Teams zuweisen",
    "full": "Voll",
    "free": "Frei",
    "partial": "Teilweise",
    "not-available": "Nicht verfügbar",
    "oof": "Außer Haus",
    "working-elsewhere": "Andernorts arbeiten",
    "delete": "Löschen",
    "save-company-holiday": "Unternehmensurlaub speichern",
    "delete-holiday": "Urlaub löschen",
    "delete-account": "Alle Teams und Daten entfernen",
    "book": "Buchen",
    "view": "Anzeigen",
    "delete-event-project": "Ereignis löschen",
    "view-subscription": "Zahlungsmethode verwalten",
    "create-subscription": "Abonnement erstellen",
    "try-again": "Erneut versuchen",
    "month-view": "Monatsansicht",
    "year-view": "Jahresansicht",
    "download-office-attendees": "Bürobericht herunterladen (.xls)",
    "download-car-park-attendees": "Parkplatzbericht herunterladen (.xls)",
    "team-report": "Teambericht",
    "department-report": "Abteilungsbericht",
    "user-report": "Benutzerbericht",
    "create-team": "Team erstellen",
    "turn-on-in-settings": "In den Einstellungen aktivieren",
    "log-in": "Anmelden",
    "today": "Heute",
    "add-new-space": "Neuen Platz hinzufügen",
    "show-more": "Mehr anzeigen",
    "show-less": "Weniger anzeigen",
    "yes": "Ja",
    "week-view": "Wochenansicht",
    "workgroup-report": "Arbeitsgruppenberichte"
  },
  "loading": {
    "saving-whereabouts": "Aufenthaltsorte werden gespeichert"
  },
  "View floor plan": "Grundriss anzeigen",
  "dates": {
    "this-week": "Diese Woche"
  },
  "checkbox": {
    "first-aider": "Ersthelfer",
    "fire-warden": "Brandschutzbeauftragter",
    "mental-first-aider": "Psychologischer Ersthelfer",
    "key-holder": "Schlüsselverantwortlicher"
  },
  "whereaboutsAvailability": {
    "show-avail-calendar-like": "Verfügbarkeit im Kalender anzeigen als:",
    "show-as-free": "Dies wird im Kalender als <strong>Frei</strong> angezeigt.",
    "show-as-tentative": "Dies wird im Kalender als <strong>Vorläufig</strong> angezeigt.",
    "show-as-busy": "Dies wird im Kalender als <strong>Beschäftigt</strong> angezeigt.",
    "show-as-oof": "Dies wird im Kalender als <strong>Außer Haus</strong> angezeigt (nur Outlook).",
    "show-as-working-elsewhere": "Dies wird im Kalender als <strong>Andernorts arbeiten</strong> angezeigt (nur Outlook)."
  },
  "company-settings-page": {
    "whereabouts-management-tab": "Aufenthaltsorte verwalten",
    "visitors-tab": "Besucher",
    "edit-company": "Unternehmen bearbeiten",
    "company-settings": "Unternehmenseinstellungen",
    "company-preferences": "Unternehmenspräferenzen",
    "edit-global": "Globale Einstellungen bearbeiten",
    "signup-and-register": "Anmelde- und Registrierungseinstellungen",
    "azure-and-active-dir-settings": "Azure- und Active Directory-Einstellungen",
    "other": "Andere Einstellungen",
    "notifications": "Benachrichtigungseinstellungen",
    "tenant-id": "Azure-Mandanten-ID",
    "general": "Allgemein",
    "danger-zone": "Gefahrenzone",
    "notifications-tab": "Benachrichtigungen",
    "signup-and-register-tab": "Anmeldung und Registrierung",
    "azure-configuration": "Azure-Konfiguration",
    "other-tab": "Sonstiges",
    "api-keys-tab": "API Keys",
    "api-keys": {
      "public-api": {
        "title": "Public API key",
        "description": "Used by external integrations calling the Team Today public API."
      },
      "scim": {
        "title": "SCIM API key",
        "description": "Used by SCIM clients to provision and sync users."
      },
      "no-key": "No key generated yet.",
      "label": "Label",
      "label-placeholder": "e.g. Okta production",
      "unlabeled": "Unlabeled",
      "edit-label": "Edit label",
      "save-label": "Save",
      "cancel": "Cancel",
      "generate": "Generate key",
      "generate-additional": "Generate new key",
      "regenerate": "Regenerate",
      "revoke": "Revoke",
      "copy": "Copy",
      "copied": "Copied!",
      "confirm-regenerate": "This will invalidate the current key. Any integration using it will stop working. Continue?",
      "confirm-revoke": "This will delete the current key. Any integration using it will stop working. Continue?"
    }
  },
  "company-view-page": {
    "workgroups": "Arbeitsgruppen",
    "choose-office-to-view": "Büro auswählen",
    "create-an-office": {
      "title": "Büro erstellen",
      "description": "Legen Sie eine Grenze für die Anzahl der verfügbaren Büroschreibtische fest, damit Kollegen wissen, wann sie ins Büro kommen können."
    },
    "sidebar": {
      "create-work-group": "Arbeitsgruppe erstellen?",
      "create-work-group-description": "Erstellen Sie Arbeitsgruppen, um Benutzern zu ermöglichen, in mehr als einem Team zu sein"
    },
    "all-teams": "Alle Teams",
    "work-groups": "Arbeitsgruppen",
    "create-new-group": "Neue Gruppe erstellen?",
    "create-new-department": "Neue Abteilung erstellen?",
    "no-members-in-workgroup": "Noch keine Mitglieder in der Arbeitsgruppe",
    "no-members-in-workgroup-description": "Arbeitsgruppen ermöglichen es Benutzern, in mehr als einem Team oder einer Abteilung zu sein",
    "area-unavailable": "'Bereich - Nicht verfügbar'",
    "area": "Bereich:",
    "no-one-booked-in-area": "Niemand hat in diesen Bereich gebucht",
    "departments": "Abteilungen"
  },
  "custom-whereabouts-page": {
    "whereabouts": "Aufenthaltsorte",
    "available-in-team-view": "Verfügbar in der Team-Ansicht, Aufenthaltsorte ermöglichen Ihrem Team, ihre Arbeitswoche zu planen.",
    "how-it-works": "So funktioniert es",
    "custom-whereabouts-requirements": "Die folgenden Aufenthaltsorte sind für das System erforderlich, aber Sie können unten weitere benutzerdefinierte Aufenthaltsorte hinzufügen.",
    "promo-title": "Benutzerdefinierte Aufenthaltsorte erstellen und verwalten",
    "promo-message": "Fügen Sie benutzerdefinierte Aufenthaltsorte hinzu, um Ihren Teams mehr Optionen wie Extern, Schulung, Krankheit zu geben und detaillierte Berichte im Berichtsbereich zu erhalten.",
    "enable-whereabouts-option": "Diesen Aufenthaltsort aktivieren",
    "day-notes-title": "Tagesnotizen aktivieren",
    "day-notes-description": "Fügt ein Freitextfeld zur Aufenthaltsortoption hinzu",
    "schengen-title": "Schengen-Erfassung aktivieren",
    "schengen-description": "Dieser Aufenthaltsort zählt als Schengen-Tag",
    "description": "Ermöglichen Sie Ihrem Team, die Arbeitswoche zu planen.",
    "default": "Standard",
    "create-title": "Benutzerdefinierten Aufenthaltsort erstellen",
    "step-1-name": "1. Name des Aufenthaltsorts",
    "step-2-icon": "2. Symbol auswählen",
    "step-3-availability": "3. Verfügbarkeit im Outlook- oder Google-Kalender anzeigen als:",
    "final-setup": "Abschließende Einrichtung",
    "option-list-title": "Nutzern eine Auswahlliste anbieten",
    "option-list-description": "Wenn ein Nutzer diesen Aufenthaltsort auswählt, wird er gebeten, aus der folgenden Liste zu wählen",
    "option-list-upsell": "Auswahllisten sind in den Tarifen Premium und Enterprise verfügbar.",
    "option-list-upsell-link": "Tarif upgraden",
    "option-list-not-enabled": "Diese Funktion ist für Ihr Konto nicht aktiviert. Kontaktieren Sie",
    "option-list-add-option": "Option hinzufügen",
    "option-list-free-text-title": "Freitext erlauben",
    "option-list-free-text-description": "Nutzer können auch eine eigene Antwort eingeben, statt aus der Liste zu wählen",
    "delete-whereabouts": "Diesen Aufenthaltsort löschen"
  },
  "dialog": {
    "create-workgroup": "Arbeitsgruppe erstellen",
    "add-new-team": "Neues Team hinzufügen",
    "add-people-to-team-message": "OK, lassen Sie uns einige Personen zu diesem Team hinzufügen",
    "max-teams-header-msteams": "Sie haben keine Teams mehr",
    "max-teams-header": "Sie haben die maximale Anzahl an Teams erreicht",
    "max-teams-message-msteams": "Sie haben die maximale Anzahl an Teams erreicht.",
    "max-teams-message": "Sie haben Ihr Team-Kontingent aufgebraucht, löschen Sie einige oder upgraden Sie Ihr Konto.",
    "add-company-to-add-more-teams": "Fügen Sie ein Unternehmen hinzu, um mehr Teams hinzuzufügen",
    "add-self-to-team": "Sich selbst zum Team hinzufügen",
    "add-self-to-team-warning": "Dies aktualisiert das aktuelle Team, in dem Sie sich befinden.",
    "selected-number-of-users-to-report-to-a-user": "Sie haben {{userCount}} Personen ausgewählt, die dieser Person unterstellt sind.",
    "week-notes": "Wochennotizen",
    "no-week-notes": "Keine Notizen für das Team festgelegt",
    "week-note-request-not-made": "Anfrage wurde noch nicht gestellt",
    "week-notes-not-in-a-team": "Sie sind in keinem Team. Sie können nur eine Notiz festlegen, wenn Sie in einem Team sind.",
    "add-note": "Notiz hinzufügen",
    "week-note-last-updated": "Aktualisiert {{lastUpdated}}",
    "saved-whereabouts-errors-title": "Wichtig: Einige Ihrer zukünftigen Schreibtischbuchungen konnten nicht gespeichert werden",
    "saved-whereabouts-errors-content-1": "Die Bürobuchungsrichtlinie Ihres Unternehmens begrenzt zukünftige Buchungen für {{officeName}} auf {{weeksAhead}} Wochen im Voraus.",
    "saved-whereabouts-errors-content-2": "Derzeit können Sie {{officeName}} nur bis zur Woche, die am {{weekEnding}} endet, buchen.",
    "saved-whereabouts-errors-content-2-fallback": "Derzeit können Sie keine Aufenthaltsorte buchen, die so weit im Voraus liegen.",
    "parking-whereabouts-errors-title": "Parken an einigen Tagen nicht verfügbar",
    "parking-whereabouts-errors-date": "Kein Parkplatz verfügbar am {{date}}",
    "general-whereabouts-errors-title": "",
    "unable-to-book-desks-far-in-advance-title": "Schreibtische können nicht zu weit im Voraus gebucht werden",
    "unable-to-book-desks-far-in-advance-para1": "Die Bürobuchungsrichtlinie Ihres Unternehmens begrenzt zukünftige Buchungen für das Büro {{officeName}} auf {{bookingWindow}} Wochen im Voraus.",
    "unable-to-book-desks-far-in-advance-para2": "Derzeit können Sie das Büro {{officeName}} nur bis zur Woche, die am {{weekCommencing}} beginnt, buchen.",
    "unable-to-book-desks-far-in-advance-days_one": "Die Bürobuchungsrichtlinie Ihres Unternehmens begrenzt zukünftige Buchungen für das Büro {{officeName}} auf {{count}} Tag im Voraus.",
    "unable-to-book-desks-far-in-advance-days_other": "Die Bürobuchungsrichtlinie Ihres Unternehmens begrenzt zukünftige Buchungen für das Büro {{officeName}} auf {{count}} Tage im Voraus.",
    "unable-to-book-desks-far-in-advance-workdays_one": "Die Bürobuchungsrichtlinie Ihres Unternehmens begrenzt zukünftige Buchungen für das Büro {{officeName}} auf {{count}} Arbeitstag im Voraus.",
    "unable-to-book-desks-far-in-advance-workdays_other": "Die Bürobuchungsrichtlinie Ihres Unternehmens begrenzt zukünftige Buchungen für das Büro {{officeName}} auf {{count}} Arbeitstage im Voraus.",
    "unable-to-book-desks-far-in-advance-up-to": "Derzeit können Sie das Büro {{officeName}} nur bis zum {{lastDate}} buchen.",
    "unable-to-book-desks-far-in-advance-up-to-opens": "Derzeit können Sie das Büro {{officeName}} nur bis zum {{lastDate}} buchen. Weitere Tage werden am {{opensAt}} freigegeben.",
    "cannot-edit-approved-holiday-title": "Genehmigten Urlaub nicht bearbeitbar",
    "cannot-edit-approved-holiday-para1": "So stornieren Sie eine Urlaubsbuchung:",
    "cannot-edit-approved-holiday-list1": "Gehen Sie zum Urlaubsplaner",
    "cannot-edit-approved-holiday-list2": "Gehen Sie zum Reiter Urlaube",
    "cannot-edit-approved-holiday-list3": "Tippen Sie auf den Bearbeitungsstift bei dem Urlaub, den Sie stornieren möchten",
    "cannot-edit-approved-holiday-list4": "Urlaubsanfrage löschen",
    "cannot-edit-approved-holiday-para2": "Dadurch wird die Urlaubsanfrage storniert.",
    "booked": "Gebucht",
    "unavailable": "Nicht verfügbar"
  },
  "approved-holiday-whereabouts-errors": {
    "title": "Genehmigter Urlaub kann nicht bearbeitet werden",
    "line1": "So stornieren Sie eine Urlaubsbuchung:",
    "line2": "Gehen Sie zum <strong>Urlaubsplaner</strong>",
    "line3": "Gehen Sie zum <strong>Reiter Urlaube</strong>",
    "line4": "Tippen Sie auf den <strong>Bearbeitungsstift</strong> bei dem Urlaub, den Sie stornieren möchten",
    "line5": "<strong>Urlaubsanfrage löschen</strong>",
    "line6": "Dadurch wird die Urlaubsanfrage storniert."
  },
  "add-multiple-users-dialog": {
    "title": "Mehrere Benutzer hinzufügen"
  },
  "usage-dialog": {},
  "side-of-day-dialog": {
    "title": "Wie lange benötigen Sie den Schreibtisch?"
  },
  "day-notes-dialog": {
    "add-note": "Notiz hinzufügen",
    "recent-notes": "Aktuelle Notizen"
  },
  "whereabouts-option-picker-dialog": {
    "pick-option": "Option auswählen",
    "or-free-text": "Oder eigene Antwort eingeben",
    "skip": "Ohne Auswahl fortfahren"
  },
  "settings-page": {
    "title": "Einstellungen",
    "manage-users": "Aktuelle Benutzer verwalten",
    "manage-users-1": "Benutzer bearbeiten, verwalten und neue hinzufügen",
    "manage-users-2": "Benutzerberechtigungen und Standardbüro ändern",
    "manage-users-3": "Fügen Sie Benutzern Schlüsselrollen wie Brandschutzbeauftragte hinzu",
    "manage-teams": "Teams, Arbeitsgruppen und Abteilungen verwalten",
    "manage-teams-1": "Teams bearbeiten, verwalten und neue hinzufügen",
    "manage-teams-2": "Teammitglieder anzeigen",
    "teams-tab": "Teams",
    "workgroups-tab": "Arbeitsgruppen",
    "no-workgroups-message": "Benutzer können mehreren Arbeitsgruppen hinzugefügt werden, um Benutzer über Teams und Abteilungen hinweg zu gruppieren.",
    "departments-tab": "Abteilungen",
    "manage-departments": "Abteilungen verwalten",
    "manage-departments-1": "Abteilungen bearbeiten, verwalten und neue hinzufügen",
    "manage-departments-2": "Abteilungsmitglieder anzeigen",
    "whereabouts": "Benutzerdefinierte Aufenthaltsorte",
    "whereabouts-1": "Zusätzliche Aufenthaltsorte auswählen",
    "whereabouts-2": "Mehrere externe Standorte hinzufügen",
    "reports": "Berichte, Daten und Audit-Protokolle",
    "report-1": "Berichte zur Büronutzung anzeigen",
    "report-2": "Berichte zu Aufenthaltsorten und Urlauben anzeigen",
    "report-3": "Berichte herunterladen und nach Excel exportieren",
    "office": "Büros und Besprechungsräume",
    "office-1": "Bürostandorte, Grundrisse und Schreibtische erstellen und verwalten.",
    "office-2": "Besprechungsräume konfigurieren und mit Outlook synchronisieren.",
    "office-3": "Parkplätze und andere buchbare Bereiche verwalten.",
    "holiday": "Urlaubseinstellungen",
    "holiday-1": "Urlaubsverfolgung aktivieren und Genehmigungen einrichten",
    "holiday-2": "Urlaubsjahresbeginn und -ende ändern",
    "holiday-3": "Nationale und unternehmensweite Urlaube hinzufügen",
    "meeting-rooms": "Besprechungsräume",
    "meeting-rooms-1": "Buchbare Besprechungsräume erstellen und bearbeiten",
    "meeting-rooms-2": "Besprechungsräume mit Outlook-Besprechungsräumen synchronisieren",
    "company": "Unternehmenseinstellungen",
    "company-1": "Unternehmensweite Einstellungen steuern",
    "company-2": "Neuen Benutzern, die in Ihrem Unternehmen sind, die Anmeldung erlauben",
    "company-3": "Symbolpaket ändern und wiederkehrende Pläne einrichten",
    "personal": "Persönliche Einstellungen",
    "personal-pref-1": "Kalendersynchronisation verwalten (Outlook und Gmail)",
    "personal-pref-2": "Bevorzugte Büros und Schreibtische verwalten",
    "personal-pref-3": "Fahrzeuginformationen für Parkplätze eingeben",
    "billing": "Abrechnungs- und Planeinstellungen",
    "billing-1": "Ihr Abonnement erhöhen oder verringern",
    "billing-2": "Ihre Rechnungen und Quittungen anzeigen",
    "how-desk-capacities-work": "Aktivieren Sie die Schreibtischbuchung, wenn Sie Bürokapazitäten verwalten oder ein Büro in Etagen und Bereiche aufteilen möchten. Wenn Sie einen interaktiven Grundriss einbeziehen möchten, senden Sie einfach eine Referenzskizze an <0>hello@team-today.com</0>.",
    "how-desk-capacities-work-title": "So funktioniert es",
    "edit-user": {
      "title": "Benutzer bearbeiten",
      "email-address": "E-Mail-Adresse",
      "member-of-team": "Mitglied des Teams",
      "member-of-department": "Mitglied der Abteilung",
      "member-of-workgroups": "Mitglied von Arbeitsgruppen",
      "not-assigned-to-workgroups": "Keinen Arbeitsgruppen zugewiesen",
      "location-title": "Standort",
      "location-message": "Die Festlegung eines Standardstandorts erleichtert Kollegen die Auswahl eines Schreibtisches. Sie können immer noch jedes Büro auswählen, das sie besuchen möchten.",
      "office-base": "Bürostandort",
      "standard-user": "Standardbenutzer",
      "basic-permissions": "Kann nur eigene Aufenthaltsorte festlegen",
      "department-admin-permissions-1": "Volle Abteilungsverwaltung",
      "department-admin-permissions-2": "Kann alle Benutzer innerhalb der Abteilung anzeigen und aktualisieren",
      "department-admin": "Abteilungsadmin",
      "team-admin": "Team-Admin",
      "team-admin-permissions-1": "Volle Teamverwaltung, einschließlich Hinzufügen und Entfernen von Teammitgliedern",
      "team-admin-permissions-2": "Kann neue Benutzer hinzufügen und Benutzerinformationen aktualisieren",
      "team-admin-permissions-3": "Kann andere Benutzer zu Team-Admins machen",
      "office-admin": "Büro-Admin",
      "office-admin-permissions-1": "Volle Büroverwaltung des standardmäßig zugewiesenen Büros des Benutzers",
      "office-admin-permissions-2": "Kann Aufenthaltsorte anderer Benutzer aktualisieren",
      "office-admin-permissions-3": "Zugriff auf Büroberichte",
      "office-admin-permissions-4": "Kann andere Benutzer zu Team-Admins machen",
      "company-admin": "Unternehmens-Admin",
      "company-admin-permissions-1": "Volle Unternehmensverwaltung, einschließlich Erstellen und Löschen von Teams",
      "company-admin-permissions-2": "Unternehmensdetails bearbeiten",
      "company-admin-permissions-3": "Benutzer in jedem Team hinzufügen oder entfernen",
      "permissions": "Berechtigungen",
      "holiday-allowance": "Individueller Urlaubsanspruch für das Jahr",
      "holiday-allowance-message": "Dies überschreibt den standardmäßigen Unternehmensurlaubsanspruch. Dies wird zu Beginn des Urlaubsjahres auf den Unternehmensstandard zurückgesetzt.",
      "users-allowance": "Urlaubsanspruch für das Jahr festlegen",
      "for-year": "Tage für das Jahr",
      "holiday-allowance-taken-from-users-setting": "Der aktuelle Urlaubsanspruch wird aus dieser Benutzereinstellung entnommen",
      "holiday-allowance-taken-from-company-setting": "Der aktuelle Urlaubsanspruch wird aus den Unternehmenseinstellungen entnommen",
      "holiday-allowance-not-yet-set": "Der aktuelle Urlaubsanspruch wurde weder in den Unternehmenseinstellungen noch in dieser Benutzereinstellung festgelegt.",
      "additional-responsibilities": "Zusätzliche Verantwortlichkeiten",
      "additional-responsibilities-message": "Erstellen Sie Brandschutzbeauftragte und Ersthelfer, damit Sie leicht sehen können, ob welche in ein Büro gebucht sind.",
      "access-permitted-title": "Zugriff auf Team Today",
      "access-permitted-description": "Der Benutzer bleibt in Team Today bestehen, kann sich aber nicht anmelden.",
      "birthday": {
        "title": "Geburtstag teilen",
        "description": "Lassen Sie andere wissen, wann Ihr Geburtstag bevorsteht. Dies wird in der Team-Ansicht und im Arbeitsplaner angezeigt.",
        "month": "Monat",
        "day": "Tag"
      },
      "profile-tab": "Profil",
      "team-tab": "Team und Gruppen",
      "office-tab": "Büro",
      "access-tab": "Zugriff und Berechtigungen",
      "leave-tab": "Urlaub",
      "responsibilities-tab": "Verantwortlichkeiten",
      "teams-section": "Teams",
      "groups-section": "Gruppen",
      "delete-title": "Diesen Benutzer löschen",
      "delete-description": "Beim Löschen wird dieser Benutzer aus Team Today entfernt und seine Lizenz freigegeben. Sie können ihn 30 Tage lang unter <0>Gelöschte Benutzer</0> wiederherstellen. Danach werden der Benutzer und alle seine Daten endgültig gelöscht.",
      "delete-alternative": "Wenn sich jemand nicht mehr anmelden soll, Konto und Verlauf aber erhalten bleiben sollen, deaktivieren Sie stattdessen Zugriff auf Team Today unter <0>Zugriff und Berechtigungen</0>.",
      "delete-admin-only": "Nur Unternehmensadministratoren können Benutzer löschen."
    }
  },
  "audit-logs-page": {
    "title": "Audit-Protokolle",
    "search": "Suchen",
    "search-placeholder": "Nach Person oder Beschreibung suchen",
    "action": "Aktion",
    "source": "Quelle",
    "all-actions": "Alle Aktionen",
    "all-sources": "Alle Quellen",
    "showing": "{{shown}} von {{total}} Einträgen angezeigt",
    "no-results": "Keine Audit-Protokolleinträge entsprechen Ihren Filtern.",
    "load-more": "Mehr laden",
    "error": "Audit-Protokolle konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "category": "Kategorie",
    "all-categories": "Alle Kategorien",
    "col-date": "Datum",
    "col-action": "Aktion",
    "col-user": "Benutzer",
    "col-affected": "Betroffener Benutzer",
    "col-source": "Quelle",
    "col-description": "Beschreibung",
    "categories": {
      "HOLIDAYS": "Urlaub und Abwesenheit",
      "WHEREABOUTS": "Aufenthaltsorte",
      "USER_MANAGEMENT": "Benutzerverwaltung",
      "MEETING_ROOMS": "Besprechungsräume",
      "COMPANY_SETTINGS": "Unternehmenseinstellungen",
      "SECURITY": "Sicherheit und API-Schlüssel",
      "NOTIFICATIONS": "Benachrichtigungen",
      "OFFICE_CHECK_IN": "Büro-Check-in"
    },
    "sources": {
      "WEB": "Web",
      "SCIM": "SCIM",
      "SCHEDULER": "Planer",
      "PUBLIC_API": "Öffentliche API",
      "SYSTEM": "System"
    }
  },
  "manage-users-page": {
    "title": "Benutzer verwalten",
    "search": "Nach einem Benutzer suchen",
    "showing-users": "Zeige {{skip}} - {{count}} von {{total}} Benutzern",
    "not-logged-in": "Nicht angemeldet",
    "resend-invite": "Einladung erneut senden",
    "account": "Konto",
    "user-count": "{{count}} Benutzer",
    "free-spaces-count": "{{count}} Plätze frei",
    "add-multiple-users": "Mehrere Benutzer hinzufügen",
    "assign-to-office": "Büro zuweisen",
    "assign-to-department": "Abteilung zuweisen",
    "assign-to-team": "Team zuweisen",
    "manage-teams": "Teams verwalten",
    "manage-workgroups": "Arbeitsgruppen verwalten",
    "export-users": "Benutzer exportieren",
    "assign-to-workgroup": "Arbeitsgruppe zuweisen",
    "select-all": "Alle auswählen"
  },
  "holiday": {
    "holiday-year": "Urlaubsjahr",
    "days-left": "Verbleibende Tage",
    "days-taken-or-booked": "Genommene oder gebuchte Tage",
    "company-holiday": "Unternehmensurlaub",
    "holiday-booking": "Urlaubsbuchung",
    "your-summary": "Ihre Zusammenfassung",
    "your-bookings": "Ihre Buchungen",
    "users-bookings": "Buchungen von {{firstName}}",
    "holiday-booked": "Urlaub gebucht"
  },
  "company-holiday": {
    "title": "Unternehmensurlaub",
    "description": "Unternehmensurlaube werden jedem Kalender hinzugefügt und verhindern Buchungen ins Büro",
    "number-of-holidays": "Anzahl der Urlaube"
  },
  "unsubscribe-page": {
    "unsubscribed-title": "Abgemeldet",
    "unsubscribed-message-1": "Sie haben sich von Team Today-Erinnerungs-E-Mails abgemeldet.",
    "unsubscribed-message-2": "Sie können sich wieder anmelden, indem Sie sich anmelden und den Einstellungsbereich besuchen.",
    "unsubscribed-failed-title": "Abmeldung fehlgeschlagen",
    "unsubscribed-failed-message": "Bei Ihrer Abmeldung ist ein Fehler aufgetreten.",
    "unsubscribed-contact": "Schreiben Sie uns eine E-Mail an <0>hello@team-today.com</0>, um Hilfe bei der Abmeldung zu erhalten."
  },
  "reports-page": {
    "reporting": "Berichterstattung",
    "office-usage-title": "Büronutzung",
    "office-usage-description": "Statistiken und Daten zur Büronutzung anzeigen",
    "wfh-title": "Berichte zum Arbeiten von zu Hause",
    "wfh-description": "Statistiken und Daten zum Arbeiten von zu Hause",
    "whereabouts-title": "Aufenthaltsorte",
    "all-departments": "Alle Abteilungen",
    "all-workgroups": "Alle Arbeitsgruppen",
    "whereabouts-description": "Statistiken und Daten zu allen Aufenthaltsorten",
    "unknown-title": "Unbekannte Aufenthaltsorte",
    "unknown-description": "Benutzer ohne festgelegte Aufenthaltsorte anzeigen",
    "line-reports-title": "Unterstellte Mitarbeiter",
    "line-reports-description": "Anzeigen, wer wem unterstellt ist",
    "holiday-usage-title": "Urlaubsnutzung",
    "holiday-usage-description": "Anzeigen, wie viele Tage Personen genommen haben und noch übrig haben",
    "checkin-title": "E-Mail-Check-in",
    "checkin-description": "Sehen, wer den Bürobesuch über die Check-in-E-Mail bestätigt hat",
    "automatic-checkin-title": "Automatischer Büro-Check-in",
    "automatic-checkin-description": "Automatische Check-ins durch Netzwerkerkennung anzeigen",
    "automatic-checkin-log-title": "Check-in-Protokoll",
    "no-shows-title": "Nichterscheinen",
    "no-shows-description": "Personen, die im Büro gebucht, aber nicht eingecheckt haben",
    "user-report": "Benutzerbericht",
    "department-report": "Abteilungsbericht",
    "user-breakdown-title": "Benutzerbericht",
    "user-breakdown-description": "Zusammenfassung der Aufenthaltsorte eines Benutzers",
    "user-breakdown-select-user-title": "Um fortzufahren",
    "user-breakdown-select-user-description": "Suchen Sie nach einem Benutzer, um eine Zusammenfassung seiner Aufenthaltsorte über einen Zeitraum anzuzeigen.",
    "fire-booked-in": "Brandschutzbeauftragte im Büro",
    "no-fire-booked-in": "Keine Brandschutzbeauftragten im Büro",
    "first-booked-in": "Ersthelfer im Büro",
    "no-first-booked-in": "Keine Ersthelfer im Büro",
    "weeks-office-usage": "Büronutzung dieser Woche",
    "updated-hourly": "Stündlich aktualisiert",
    "office-usage-report": "Büronutzungsbericht",
    "download-office-report": "Bürobericht herunterladen",
    "download-report": "Bericht herunterladen",
    "choose-an-office": "Büro auswählen",
    "no-data-found": "Keine Daten für diese Auswahl gefunden",
    "select-office-from-past-two-years": "Bitte wählen Sie ein Büro und ein vergangenes Datum innerhalb der letzten 2 Jahre aus.",
    "create-a-report": "Bericht erstellen",
    "office-usage-confirmation": "Büronutzung vs. Bestätigung",
    "typical-office-usage": "Typische Büronutzung",
    "download-holiday-summary": "Urlaubsbericht herunterladen",
    "download-absence-summary": "Abwesenheitsbericht herunterladen",
    "edit-holiday-allowance": "Urlaubsanspruch bearbeiten",
    "unknown-whereabouts": {
      "title": "Unbekannter Aufenthaltsort",
      "note": "Hinweis",
      "all-users-have-whereabouts-set": "Alle Benutzer in Ihrer Auswahl haben ihre Aufenthaltsorte festgelegt.",
      "reminder-last-sent": "Erinnerung zuletzt vor {{days}} Tagen gesendet"
    },
    "whereabouts-report": {
      "no-date": "Keine Daten für diese Auswahl gefunden",
      "select-a-date": "Bitte wählen Sie ein Datum innerhalb der letzten 2 Jahre aus.",
      "title": "Aufenthaltsbericht",
      "high-level-report": "Allgemeiner Bericht",
      "detailed-report": "Detaillierter Bericht"
    },
    "holidays-report": {
      "days-used": "Tage genutzt",
      "allowance": "Anspruch",
      "team-name": "Teamname",
      "user": "Benutzer",
      "percentage": "%",
      "holiday-year": "Urlaubsjahr: {{year}}",
      "high-level-report": "Hochrangiger Bericht .xls",
      "detailed-report": "Detaillierter Bericht .xls",
      "report": "Bericht herunterladen",
      "office": "Im Büro (Gesamt)"
    },
    "key-responsib": {
      "title": "Brandschutz und Sicherheit",
      "description": "Bericht und Daten",
      "nothing-selected": "Büro auswählen",
      "one-fire-warden": "Ein Brandschutzbeauftragter pro",
      "one-first-aider": "Ein Ersthelfer pro",
      "staff": "Mitarbeiter",
      "fire-warden": "Brandschutzbeauftragter",
      "first-aider": "Ersthelfer",
      "office-capacity": "Bürokapazität: {{officeCapacity}}",
      "people-in-office": "Personen im Büro: {{peopleInOffice}}",
      "key-role-in-office": "Schlüsselrolle im Büro: {{keyRoleInOffice}}",
      "loading": "Daten werden abgerufen, dies kann einen Moment dauern",
      "nothing-selected-title": "Nichts anzuzeigen"
    },
    "users-whereabouts-title": "Benutzeraufenthaltsorte",
    "users-whereabouts-description": "Statistiken und Daten zu einzelnen Benutzeraufenthaltsorten",
    "desk-utilization-title": "Schreibtischauslastung",
    "desk-utilization-description": "Sehen Sie, wie Schreibtische in Ihren Büros genutzt werden",
    "desk-utilization-download-description": "Laden Sie eine CSV-Datei herunter, die den täglichen Buchungsstatus jedes Schreibtischs zeigt (1 = ganzer Tag, 0,5 = halber Tag, 0 = nicht gebucht) für den ausgewählten Zeitraum.",
    "desk-utilization-report-title": "Schreibtischauslastungsbericht",
    "desk-utilization-office": "Büro",
    "desk-utilization-no-data": "Keine Daten gefunden",
    "desk-utilization-no-data-description": "Wählen Sie ein Büro und einen Zeitraum, um die Schreibtischauslastung anzuzeigen.",
    "desk-utilization-total-desks": "Gesamtzahl Schreibtische",
    "desk-utilization-total-bookings": "Gesamtzahl Buchungen",
    "desk-utilization-days-in-range": "Tage im Zeitraum",
    "desk-utilization-utilization": "Auslastung",
    "desk-utilization-by-floor": "Auslastung nach Etage",
    "desk-utilization-by-office": "Auslastung nach Büro",
    "desk-utilization-top-desks": "10 am wenigsten genutzte Schreibtische",
    "desk-utilization-top-offices": "10 am wenigsten genutzte Büros",
    "desk-utilization-company-wide": "Unternehmensweit",
    "desk-utilization-floor-breakdown": "Etagenübersicht",
    "desk-utilization-floor": "Etage",
    "desk-utilization-desks": "Schreibtische",
    "desk-utilization-bookings": "Buchungen",
    "desk-utilization-days": "Tage",
    "desk-utilization-download-title": "Schreibtischnutzungsbericht herunterladen",
    "car-park-utilization-title": "Parkplatzauslastung",
    "car-park-utilization-description": "Sehen Sie, wie Parkplätze in Ihren Büros genutzt werden",
    "audit-logs-title": "Audit-Protokolle",
    "audit-logs-description": "Sehen Sie, wer was in Ihrem Unternehmen geändert hat",
    "car-park-utilization-report-title": "Parkplatzauslastungsbericht",
    "car-park-utilization-office": "Büro",
    "car-park-utilization-no-data": "Keine Daten gefunden",
    "car-park-utilization-no-data-description": "Wählen Sie ein Büro und einen Zeitraum, um die Parkplatzauslastung anzuzeigen.",
    "car-park-utilization-total-capacity": "Gesamtkapazität",
    "car-park-utilization-total-bookings": "Gesamtzahl Buchungen",
    "car-park-utilization-days-in-range": "Tage im Zeitraum",
    "car-park-utilization-utilization": "Auslastung",
    "car-park-utilization-by-office": "Auslastung nach Büro",
    "car-park-utilization-company-wide": "Unternehmensweit",
    "car-park-utilization-office-breakdown": "Büroübersicht",
    "car-park-utilization-capacity": "Kapazität",
    "car-park-utilization-bookings": "Buchungen",
    "car-park-utilization-days": "Tage",
    "car-park-utilization-daily-breakdown": "Tagesübersicht",
    "car-park-utilization-daily-utilization": "Tägliche Auslastung",
    "car-park-utilization-date": "Datum",
    "car-park-utilization-bottom-spaces": "10 am wenigsten genutzte Parkplätze",
    "office-usage": {
      "choose-office": "Büro auswählen",
      "choose-group": "Team, Arbeitsgruppe oder Abt. wählen",
      "choose-floor": "Etage auswählen",
      "custom": "Benutzerdefinierten Zeitraum eingeben",
      "exit-custom": "Benutzerdefinierten Zeitraum verlassen",
      "download-btn": "Etagenbericht herunterladen",
      "download-desk-usage-btn": "Schreibtischnutzungsbericht herunterladen",
      "capacity": "{{capacity}}% Kapazität",
      "occupancy": "Etagenbelegung",
      "deskUsage": "Schreibtischnutzung",
      "top10Desks": "10 meistgenutzte Schreibtische",
      "bottom10Desks": "10 am wenigsten genutzte Schreibtische"
    }
  },
  "holidays": {
    "company-holidays-applies-to": "Büros auswählen, für die dies gilt:",
    "edit-holiday-title": "Urlaub bearbeiten",
    "add-holiday-title": "Urlaub hinzufügen",
    "holidays": "Mein Urlaub",
    "holidays-disabled": "Urlaubsverwaltung derzeit nicht aktiviert",
    "holidays-disable-how-to-enable": "Um die Urlaubsverwaltung einschließlich Genehmigungen zu aktivieren, schalten Sie sie einfach im Einstellungsbereich ein.",
    "holiday-duration": "{{duration}} Tage",
    "add-new-leave": "Neuen Urlaub hinzufügen",
    "add-leave": "Urlaub hinzufügen",
    "for-me": "Für mich selbst",
    "for-another": "Für ein anderes Teammitglied",
    "holiday-year-span": "Urlaubsjahr {{from}} - {{to}}",
    "booked": "Urlaub gebucht",
    "add-more-leave": "Mehr Urlaub hinzufügen",
    "leave-reporting": "Urlaubsberichterstattung",
    "days-booked": "Gebuchte Tage",
    "days-left": "Verbleibende Tage",
    "view-holidays": "Urlaube anzeigen",
    "allowance": "Anspruch: {{number}} Tage",
    "insufficient-access-title": "Admin-Zugriff erforderlich",
    "insufficient-access-description": "Um auf Daten und Berichte zuzugreifen, wenden Sie sich an Ihren Manager oder Admin, um die erforderlichen Berechtigungen anzufordern.",
    "holiday-tracking-disabled-title": "Urlaubsberichterstattung inaktiv",
    "holiday-tracking-disabled-description": "Sie können die Urlaubsberichterstattung für Manager im Hauptbereich der Einstellungen aktivieren.",
    "leave-planner-disabled-title": "Urlaubsplaner inaktiv",
    "leave-planner-disabled-description": "Sie können die Urlaubsverfolgung im Hauptbereich der Einstellungen aktivieren.",
    "carried-over": "Übertragen: {{number}} Tage"
  },
  "upgrade": "Upgrade",
  "change-pricing-plan": "Ihren Preisplan ändern",
  "get-in-touch": "Kontakt aufnehmen",
  "company": "Unternehmen",
  "help": "Hilfe",
  "faqs": "FAQs",
  "copyright": "Copyright © 2026 Team Today. Alle Rechte vorbehalten.",
  "create-new-team": "Neues Team erstellen?",
  "user-view": "Benutzeransicht",
  "User": "Benutzer",
  "Email": "E-Mail",
  "Team name": "Teamname",
  "Permissions": "Berechtigungen",
  "tag-manager": "Arbeitsgruppenmanager",
  "Back": "Zurück",
  "back-to-company-view": "Zurück zur Unternehmensansicht",
  "users": "Benutzer",
  "team members": "Teammitglieder",
  "members": "Mitglieder",
  "Add a team member": "Teammitglied hinzufügen",
  "Invite a user": "Benutzer einladen",
  "Add existing user": "Vorhandenen Benutzer hinzufügen",
  "Select a team": "Team auswählen",
  "Search results": "Suchergebnisse",
  "days": "Tage",
  "choose-office-to-view": "Büro zum Anzeigen auswählen",
  "create-an-office": "Büro erstellen",
  "create-an-office-description": "Legen Sie eine Grenze für die Anzahl der verfügbaren Büroschreibtische fest, damit Kollegen wissen, wann sie ins Büro kommen können.",
  "office-space-bookings": "Büroraumbuchungen",
  "office-space-no-bookings": "Keine Buchungen",
  "open-office": "Offener Bürobereich",
  "select-team-to-add-user-to": "Team zum Hinzufügen auswählen",
  "team-admins-limitation": "Team-Admins können Benutzer nur in ihr eigenes Team verschieben",
  "search-for-existing-user": "Nach einem vorhandenen Benutzer suchen",
  "tag-view": "Arbeitsgruppenansicht",
  "Select...": "Auswählen...",
  "did-you-know": "Wussten Sie schon?",
  "desk-reservation": "Schreibtischreservierung",
  "desk": "Schreibtisch",
  "added-to-favourites": "Zu Ihren Favoriten hinzugefügt",
  "add-to-your-favourites": "Zu Ihren Favoriten hinzufügen",
  "favouring-an-office-tip": "Ein bevorzugtes Büro macht die Auswahl schneller, wenn Sie Ihre Aufenthaltsorte für die Woche festlegen.",
  "back-to-whereabouts": "Zurück zu Aufenthaltsorten",
  "404-error": "Entschuldigung, 404. Nicht gefunden",
  "admin-access-required": "Admin-Zugriff erforderlich",
  "insufficient-rights": "Unzureichende Zugriffsrechte",
  "onboarding": {
    "add-user": {
      "title": "Teammitglied hinzufügen",
      "message": "Fügen Sie bis zu 10 Personen zu diesem Team hinzu"
    },
    "create-an-office": "Büro erstellen",
    "create-team": "Lassen Sie uns Ihr erstes Team für Ihr Unternehmen erstellen...",
    "create-team-description": "Sie können später so viele Teams erstellen, wie Sie möchten",
    "welcome-for-company": "Willkommen beim Team Today-Konto für",
    "welcome": "Willkommen bei Team Today",
    "welcome-message": "Planen Sie Ihre Aufenthaltsorte für die Arbeitswoche, buchen Sie Schreibtische, verwalten Sie Büroräume und synchronisieren Sie alles mit Ihren Arbeitskalendern.",
    "welcome-to-existing-company": "Beginnen Sie einfach damit, Ihre Aufenthaltsorte für die nächste Woche festzulegen. Dies lässt den Rest Ihres Teams Ihre Pläne wissen... so einfach ist das.",
    "choose-features": "Wählen Sie Ihre Funktionen",
    "choose-features-description": "Sie können so wenige oder so viele haben, wie Sie wünschen. Einstellungen können jederzeit in der Zukunft geändert werden.",
    "whereabouts-feature": "Aufenthaltsorte",
    "whereabouts-feature-description": "Eine einfache Schnittstelle, die alle wissen lässt, wo sich jeder in der Woche befindet.",
    "deskbooking-feature": "Schreibtischbuchung und Parkplätze",
    "deskbooking-feature-description": "Behalten Sie Büroräume im Auge und sehen Sie, wie viele Schreibtische verfügbar sind. Buchen Sie sogar Parkplätze.",
    "holiday-management-feature": "Urlaubsverwaltung",
    "holiday-management-feature-description": "Fügen Sie Vorgesetzte hinzu und autorisieren Sie Urlaube über Team Today.",
    "office-created-title": "Büro erstellt",
    "office-created-message": "Sie können später die Einstellungen besuchen, um mehrere Büros, Etagen, Bereiche zu erstellen und einen interaktiven Grundriss für Kollegen zum Buchen hinzuzufügen.",
    "team-required": "Team erforderlich",
    "create-office-reasoning": "Sie können mehrere Büros für Teammitglieder zum Besuchen erstellen.",
    "holiday-management": "Urlaubsverwaltung",
    "holiday-management-description": "Lassen Sie Teammitglieder verbleibende Tage verfolgen und mit dem gesamten Team teilen.",
    "holiday-management-default-number": "Standardanzahl der Urlaubstage",
    "holiday-management-tip": "Sie können individuelle Urlaubsansprüche und ein Erneuerungsdatum in den Einstellungen festlegen",
    "custom-whereabouts-title": "Erstellen und verwalten Sie benutzerdefinierte Aufenthaltsorte und Arbeitsorte einfach",
    "custom-whereabouts-description": "Besuchen Sie den Einstellungs-/Verwaltungsbereich in Team Today, um benutzerdefinierte Aufenthaltsorte wie Baustelle, Schulung oder Kundenbesuch zu erstellen und sie automatisch mit Ihren E-Mail-Kalendern zu synchronisieren.",
    "icons-title": "Wählen Sie Ihren Symbolstil",
    "icons-description": "Wählen Sie den Stil, der am besten zu Ihrem Unternehmen passt",
    "icons-detailed": "Detaillierte Symbole",
    "icons-simple": "Einfache Symbole",
    "onboarding-complete": "Alles eingerichtet...",
    "onboarding-complete-description": "Vergessen Sie nicht, Sie können die Team Today-App aus dem Microsoft Teams-Store herunterladen und sich anmelden.",
    "add-to-ms-teams": "Zu Microsoft Teams hinzufügen",
    "required": "ERFORDERLICH"
  },
  "dialog-headers": {
    "sync-to-outlook": "Für die beste Erfahrung, synchronisieren Sie Team Today mit Ihrem Outlook-Kalender",
    "cannot-be-deleted": "Das kann nicht gelöscht werden",
    "are-you-sure": "Sind Sie sicher?",
    "update-desk": "Schreibtisch aktualisieren",
    "edit-tags": "Arbeitsgruppen bearbeiten",
    "add-group-member": "Gruppenmitglied hinzufügen",
    "manage-favourites": "Favoriten verwalten",
    "filter-selection": "Filterauswahl",
    "whereabouts-have-been-edited": "Ihre Aufenthaltsorte wurden bearbeitet",
    "team-created": "Team erstellt",
    "choose-area": "Bereich auswählen",
    "choose-floor": "Etage auswählen",
    "choose-office": "Büro auswählen",
    "add-custom-whereabouts": "Benutzerdefinierte Aufenthaltsorte hinzufügen",
    "company-created": "Unternehmen erstellt",
    "payment-failed": "Zahlung fehlgeschlagen",
    "payment-successful": "Zahlung erfolgreich",
    "select-line-reports": "Unterstellte Mitarbeiter auswählen"
  },
  "payments": {
    "users-available-message": "Sie können {{remainingUsers}} weitere Teammitglieder zu diesem Konto hinzufügen.",
    "upgrade-account-in-settings": "Upgraden Sie Ihr Konto in den Einstellungen",
    "with-as-many-users": "Mit einem kostenpflichtigen Konto können Sie so viele Benutzer hinzufügen, wie Sie möchten.",
    "how-many-users-you-need": "Wie viele Benutzer benötigen Sie?",
    "manage-total-users": "Gesamtbenutzer verwalten",
    "payment-method": "Zahlungsmethode",
    "card-payment": "Kartenzahlung",
    "bank-transfer": "Banküberweisung",
    "bank-transfer-contact": "Um Ihren Tarif per Banküberweisung zu verwalten, kontaktieren Sie <0>hello@team-today.com</0> mit Ihren Unternehmensdaten",
    "bank-transfer-annual-only": "Nur Jahrestarife",
    "bank-transfer-currencies": "Für Banküberweisungen akzeptieren wir nur GBP und Euro",
    "bank-transfer-po": "Wir akzeptieren Bestellungen (PO)",
    "how-often-you-pay": "Zahlungshäufigkeit",
    "currency": "Währung",
    "first-10-users": "Erste 10 Benutzer",
    "FREE": "KOSTENLOS",
    "total-paid-users": "Gesamte kostenpflichtige Benutzer",
    "monthly-amount": "Monatlich zu zahlender Betrag",
    "year-amount": "Jährlich zu zahlender Betrag",
    "looking-to-cancel": "Möchten Sie kündigen?",
    "looking-to-cancel-message": "Wir würden Sie ungern gehen sehen, aber Sie können Ihr Abonnement jederzeit kündigen, indem Sie eine E-Mail an <0>hello@team-today.com</0> senden.",
    "free-trial-ends": "Kostenlose Testphase endet",
    "view-payment-plan": "Ihren Zahlungsplan anzeigen",
    "choose-plan": "Wählen Sie Ihren Tarif",
    "standard": "Standard",
    "free-plan": "Kostenloser Tarif",
    "professional-plan": "Professional-Tarif",
    "premium-plan": "Premium-Tarif",
    "enterprise-plan": "Enterprise-Tarif",
    "professional": "Professional",
    "premium": "Premium",
    "enterprise": "Enterprise",
    "professional-features": "Bis zu 6 benutzerdefinierte Aufenthaltsorte",
    "premium-features": "Besucherbuchung und bis zu 32 benutzerdefinierte Aufenthaltsorte",
    "enterprise-features": "Dedizierter Kundenbetreuer und Onboarding-Unterstützung",
    "your-plan": "Ihren Tarif verwalten",
    "manage-subscription": "Abonnement aktualisieren",
    "manage-subscription-title": "Ihr Abonnement",
    "nav-your-plan": "Ihr Tarif",
    "nav-invoices": "Rechnungen",
    "current-plan": "Aktueller Tarif",
    "looking-to-upgrade": "Möchten Sie upgraden?",
    "contact-us": "Kontaktieren Sie uns",
    "upgrade-plan": "Tarif upgraden",
    "upgrade-contact-title": "Abonnement upgraden oder ändern",
    "manage-plan-title": "Verwalten Sie Ihren Tarif",
    "manage-plan-body": "Um Ihre Lizenzanzahl anzupassen oder Ihren Abonnementtarif zu ändern, kontaktieren Sie uns bitte unter <0>hello@team-today.com</0>. Wir aktualisieren Ihre Kontodaten und kümmern uns um anteilige Abrechnungsanpassungen für Sie.",
    "enterprise-contact-body": "Um auf unseren Enterprise-Tarif umzusteigen, kontaktieren Sie uns bitte unter <0>hello@team-today.com</0>, um mit einem Account-Manager zu sprechen.",
    "your-payment-plan": "Ihr Zahlungsplan",
    "plan-pill": "{{plan}}-Tarif",
    "monthly-plan": "Monatlicher Tarif",
    "annual-plan": "Jährlicher Tarif",
    "total-licences": "Lizenzen insgesamt: {{licences}}",
    "plan-cost-summary-monthly": "{{cost}} / Monat - Monatlich abgerechnet",
    "plan-cost-summary-yearly": "{{cost}} / Jahr - Jährlich abgerechnet",
    "next-renewal": "Nächste Verlängerung: {{date}}",
    "custom-whereabouts-count": "{{number}} x Benutzerdefinierte Aufenthaltsorte",
    "unlock-more-premium": "mehr mit Premium freischalten",
    "meeting-rooms-count": "{{number}} x Besprechungsräume",
    "professional-custom-whereabouts": "32 x Benutzerdefinierte Aufenthaltsorte",
    "professional-meeting-rooms": "24 x Besprechungsräume",
    "advanced-reporting": "Erweiterte Berichte",
    "priority-support": "Priorisierter Support",
    "interactive-floor-plans": "Interaktive Grundrisse",
    "car-parking": "Parkplätze",
    "free-trial": "Kostenlose Testphase",
    "change-plan-hint": "Ein Tarifwechsel wird sofort wirksam; Ihre nächste Rechnung wird anteilig berechnet.",
    "confirm-plan-change": "Ihren Abonnement-Tarif jetzt ändern? Ihre nächste Rechnung wird anteilig berechnet.",
    "confirm-plan-change-title": "Tarif ändern",
    "confirm-plan-change-button": "Änderung bestätigen",
    "plan-changed": "Ihr Tarif wurde aktualisiert",
    "plan-change-failed": "Wir konnten Ihren Tarif nicht ändern, bitte kontaktieren Sie hello@team-today.com",
    "downgrade-contact-support": "Um Ihren Tarif herabzustufen, kontaktieren Sie bitte <0>support@team-today.com</0>",
    "manage-seats": "Gesamtlizenzen verwalten",
    "seats-in-use": "{{used}} von {{total}} kostenpflichtigen Benutzerplätzen belegt",
    "licences-in-use": "{{used}} von {{total}} Lizenzen derzeit genutzt",
    "price-per-licence": "Preis pro Lizenz",
    "licences": "Lizenzen",
    "total": "Gesamt",
    "period-month": "Monat",
    "period-year": "Jahr",
    "update-seats": "Plätze aktualisieren",
    "seats-change-hint": "Eine Änderung der bezahlten Plätze wird sofort wirksam; Ihre nächste Rechnung wird anteilig berechnet.",
    "seats-updated": "Ihre bezahlten Plätze wurden aktualisiert",
    "seats-update-failed": "Wir konnten Ihre bezahlten Plätze nicht aktualisieren, bitte kontaktieren Sie hello@team-today.com",
    "update-licenses": "Abonnement aktualisieren",
    "licenses-updated": "Ihre Lizenzen wurden aktualisiert",
    "licenses-update-failed": "Wir konnten Ihre Lizenzen nicht aktualisieren, bitte kontaktieren Sie hello@team-today.com",
    "past-invoices": "Frühere Rechnungen",
    "view-invoice": "Ansehen",
    "no-invoices": "Noch keine früheren Rechnungen",
    "invoices-load-failed": "Wir konnten Ihre Rechnungen derzeit nicht laden",
    "invoice-date": "Datum",
    "invoice-amount": "Betrag",
    "invoice-status": "Status"
  },
  "team": {
    "empty-team-title": "Keine Mitglieder in diesem Team",
    "empty-team-description": "Keine Sorge, Sie können einige hinzufügen",
    "team-member-invited": "Teammitglied eingeladen",
    "add-more-users-message": "Sie können jetzt oder später weitere Teammitglieder über die App hinzufügen",
    "add-more-users-message-with-limit": "Sie können <0>{remainingUsers} weitere</0> Teammitglieder zu Ihrem <1>kostenlosen Konto</1> hinzufügen",
    "remaining-users": "{{remainingUsers}} weitere",
    "free-account": "kostenloses Konto",
    "paid-account-upsell": "Mit einem kostenpflichtigen Konto können Sie so viele Benutzer hinzufügen, wie Sie möchten. Richten Sie eine KOSTENLOSE 30-Tage-Testphase ein, indem Sie eine E-Mail an: hello@team-today.com senden.",
    "upgrade-link": "Oder upgraden Sie Ihr Konto in den Einstellungen",
    "restricted-team-title": "Dieses Team ist privat",
    "restricted-team-description": "Um Zugriff auf dieses Team zu erhalten, bitten Sie einen Administrator, Sie hinzuzufügen."
  },
  "whereabouts": {
    "select-floor": "Etage auswählen",
    "select-floor-description": "Wählen Sie eine Etage aus, um das Büro anzuzeigen und Ihren Schreibtisch zu buchen.",
    "looking-after-multiple-teams": "Verwalten Sie mehrere Teams?",
    "create-company-view": "Erstellen Sie eine Unternehmensansicht, um alle Ihre Teams an einem Ort zu sehen",
    "custom-whereabouts": "Benutzerdefinierte Aufenthaltsorte",
    "add-custom-whereabouts": "Benutzerdefinierte Aufenthaltsorte hinzufügen",
    "whereabouts-set-for-this-week": "Aufenthaltsorte für diese Woche festgelegt",
    "all-done": "Alles erledigt",
    "available-areas": "Verfügbare Bereiche",
    "available-desks": "Schreibtisch über Dropdown auswählen",
    "seats-available": "{{remaining}} Plätze verfügbar",
    "add-favourite": "Favorit hinzufügen",
    "favouriting-suggestion-title": "Wechseln Sie regelmäßig das Büro?",
    "favouriting-suggestion-description": "Ein bevorzugtes Büro macht die Auswahl schneller, wenn Sie Ihre Aufenthaltsorte für die Woche festlegen.",
    "no-offices": "Keine Büros!",
    "no-offices-description": "Fügen Sie ein oder mehrere Büros in den Einstellungen hinzu, um diese Funktion vollständig zu nutzen.",
    "add-office-button": "Büro hinzufügen",
    "num-of-group-members": "{{count}} Gruppenmitglieder",
    "desks-available": "Schreibtische verfügbar",
    "parking-available": "Parkplätze verfügbar",
    "no-available": "Keine Parkplätze",
    "require-parking-space": "Parkplatz erforderlich",
    "require-weekly-schedule": "Wöchentlichen Plan wiederholen",
    "parking": "Parken",
    "car-park-bookings": "Parkplatzbuchungen",
    "car-park-capacity-and-usage": "{{spaces}} Plätze - {{bookings}} Buchungen",
    "select-on-floor-plan": "Schreibtisch auf Grundriss auswählen",
    "repeat-schedule": {
      "title": "Wöchentlichen Plan wiederholen",
      "alternate-weeks": "Abwechselnd",
      "repeat-schedule-for": "Jede Woche wiederholen für",
      "weeks": "Wochen",
      "confirm-schedule": "Plan bestätigen",
      "cancel": "Abbrechen",
      "close": "Schließen",
      "updating": "Ihre Wochen werden aktualisiert. Dies kann einen Moment dauern.",
      "cannot-be-done-setting-not-set": "Diese Funktion kann nicht verwendet werden. Bitten Sie einen Unternehmensadmin, in den Unternehmenseinstellungen die Anzahl der Wochen zu konfigurieren, die Sie festlegen können."
    }
  },
  "office-checkin-page": {
    "title": "Danke",
    "confirmed": "Das wurde bestätigt.",
    "login-message": "Sie können sich jetzt anmelden, um Ihre oder die Aufenthaltsorte Ihrer Kollegen anzuzeigen."
  },
  "delete-team-dialog": {
    "title": "Team löschen",
    "description": "Sind Sie sicher, dass Sie dieses Team löschen möchten?",
    "warning-message": "Benutzer können sich weiterhin anmelden, werden aber keinem Team zugewiesen"
  },
  "sync-to-outlook-dialog": {
    "yes": "Ja, mit Outlook synchronisieren",
    "no": "Vielleicht später",
    "message": "Sie können dies später einrichten, indem Sie die Einstellungen besuchen und Ihre persönlichen Einstellungen bearbeiten."
  },
  "whereabouts-changed-dialog": {
    "accept-message": "Um die Änderungen zu akzeptieren, tippen Sie einfach auf die Schaltfläche „Änderungen akzeptieren“ und synchronisieren Sie sie mit Ihrem Kalender.",
    "accept-with-no-outlook-sync-1": "Um die Änderungen zu akzeptieren, tippen Sie einfach auf die Schaltfläche „Änderungen akzeptieren“.",
    "accept-with-no-outlook-sync-2": "Sie können sie mit Ihrem Microsoft 365- oder Google-Konto synchronisieren, indem Sie die Option in den Einstellungen aktivieren.",
    "accept-and-sync": "Änderungen akzeptieren und mit Kalender synchronisieren",
    "accept": "Änderungen akzeptieren"
  },
  "delete-desk-dialog": {
    "message": "Das Löschen des Büros löscht Folgendes:",
    "a-desk": "1 Schreibtisch",
    "bookings": "{{count}} Aufenthaltsortbuchung(en)",
    "cannot-be-deleted": "Dieser Schreibtisch gehört zu einer Etage, die einen Grundriss hat. Bitte kontaktieren Sie uns unter <a href=\"mailto:support@team-today.com\">support@team-today.com</a>, wenn Sie ihn löschen möchten."
  },
  "delete-office-dialog": {
    "message": "Das Löschen des Büros löscht Folgendes:",
    "office": "{{count}} Büro(s)",
    "floor": "{{count}} Etage(n)",
    "area": "{{count}} Bereich(e)",
    "desk": "{{count}} Schreibtisch(e)",
    "favourites": "{{count}} Favorit(en)",
    "cannot-be-deleted-message": "Dieses Büro enthält eine Etage. Bitte kontaktieren Sie uns unter <0 href=\"mailto:support@team-today.com\">support@team-today.com</0>, wenn Sie es löschen möchten."
  },
  "delete-user-dialog": {
    "description": "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
    "title": "Warnung"
  },
  "calendar": {
    "mon": "M",
    "tue": "D",
    "wed": "M",
    "thur": "D",
    "fri": "F",
    "sat": "S",
    "sun": "S",
    "choose-week": "Woche zum Anzeigen auswählen"
  },
  "ms-ad-sync": {
    "read-all-message-1": "Diese Funktion erfordert andere Berechtigungen, sie wird nur auf Ihrem Computer verwendet und keine sensiblen Informationen werden an unsere Server gesendet.",
    "read-all-message-2": "Klicken Sie hier, um Berechtigungen von Microsoft anzufordern",
    "message-1": "Unten finden Sie eine Liste aller Benutzer in Ihrem Microsoft-Konto, die nicht in Team Today sind.",
    "message-2": "Sie können schnell nach unten scrollen und Personen einladen, die Zugriff auf Team Today haben sollen.",
    "message-3": "Nach der Einladung müssen Sie sie einem Team hinzufügen, oder sie können sich selbst einem Team hinzufügen, wenn sie sich registrieren."
  },
  "room-finder": {
    "title": "Raumfinder",
    "no-selection": "Keine Besprechungsräume hinzugefügt",
    "no-meeting-rooms-in-office": "Keine Besprechungsräume in diesem Büro",
    "no-meeting-bookings": "Sie haben keine Besprechungsraumbuchungen zum Anzeigen.",
    "navigation": {
      "room-finder": "Raumfinder",
      "bookings": "Meine Buchungen",
      "open-search-panel": "Filter anzeigen",
      "filters": "Filter"
    },
    "number-of-people": {
      "title": "Anzahl der Personen",
      "any": "Beliebig",
      "1to2": "1 - 2",
      "3to5": "3 - 5",
      "6to8": "6 - 8",
      "8orMore": "8+"
    },
    "facilities": {
      "title": "Einrichtungen",
      "tv": "TV",
      "conference-call": "Konferenzanruf",
      "whiteboard": "Whiteboard",
      "charge-points": "Ladepunkte"
    },
    "floor-filter": {
      "title": "Stockwerk",
      "all-floors": "Alle Stockwerke"
    }
  },
  "room-booking-dialog": {
    "add-to-calendar": "Zum Kalender hinzufügen",
    "edit-booking-title": "Buchung bearbeiten",
    "title": "Besprechungsraum buchen",
    "meeting-title": "Besprechungstitel eingeben",
    "confirm-booking": "Buchung bestätigen",
    "cancel-booking": "Buchung stornieren",
    "save-changes": "Änderungen speichern",
    "no-booker-name": "Outlook-Buchung",
    "cannot-book-outlook-room": "Sie können diesen Besprechungsraum nicht buchen",
    "cannot-book-outlook-room-description": "Stellen Sie zunächst sicher, dass Ihre Kalendersynchronisation aktiv ist, damit wir den Raum systemweit reservieren können.",
    "booked-in-outlook-title": "Diese Besprechung wurde über Outlook gebucht.",
    "booked-in-outlook-description": "Um Änderungen an dieser Buchung vorzunehmen, gehen Sie bitte zu Ihrem Outlook-Kalender.",
    "is-teams-meeting": "Teams-Besprechung",
    "outlook-booked-meeting": "Diese Besprechung wurde über Outlook gebucht. Sie können sie hier aktualisieren, aber Änderungen werden möglicherweise nicht in Outlook angezeigt.",
    "notes": "Notizen (in Team Today festgelegt)",
    "update-booking": "Buchung aktualisieren",
    "cancel-series": "Serie stornieren",
    "apply-to-series": "Änderungen auf alle zukünftigen Termine dieser Serie anwenden",
    "outlook-link": "Outlook-Link",
    "can-not-update-outlook-meeting": "Outlook-Besprechungsdetails können nicht aktualisiert werden",
    "recurrence": "Wiederholung",
    "no-recurrence": "Keine Wiederholung",
    "daily": "Täglich",
    "weekly": "Wöchentlich",
    "monthly": "Monatlich",
    "yearly": "Jährlich",
    "for": "Für",
    "frequency-day": "Tag(e)",
    "frequency-week": "Woche(n)",
    "frequency-month": "Monat(e)",
    "frequency-year": "Jahr(e)",
    "recurrence-summary": "Findet {{frequency}} am {{dayName}} statt, endet am {{endDate}}.",
    "recurrence-summary-single": "Findet {{frequency}} am {{dayName}} statt.",
    "recurrence-summary-monthly": "Findet monatlich am {{dayOfMonth}} statt, endet am {{endDate}}.",
    "recurrence-summary-monthly-single": "Findet monatlich am {{dayOfMonth}} statt.",
    "recurrence-summary-daily": "Findet jeden Werktag (Mo-Fr) statt, endet am {{endDate}}.",
    "recurrence-summary-daily-single": "Findet jeden Werktag (Mo-Fr) statt.",
    "or-until": "Bis"
  },
  "delete-meeting-room-dialog": {
    "delete-meeting-room": "Besprechungsraum löschen",
    "confirm-delete-meeting-room": "Ja, diesen Besprechungsraum löschen",
    "capacity": "Ca. {{capacity}} Personen",
    "cancel": "Nein, diesen Besprechungsraum behalten"
  },
  "reset-desks-dialog": {
    "reset-desks": "Ausgewählte Schreibtische zurücksetzen",
    "reset-all-desks": "Sie werden die Zuweisung von {{count}} Schreibtischen zurücksetzen",
    "cancel": "Abbrechen"
  },
  "link-group-to-office-dialog": {
    "title": "Team oder Arbeitsgruppe mit Büro verknüpfen",
    "office-label": "Büros auswählen",
    "link-button": "Büros verknüpfen",
    "clear-button": "Büros von Gruppen löschen"
  },
  "new-user-onboarding-dialog": {
    "title": "Willkommen bei Team Today",
    "done": "Fertig",
    "intro": "Sie können sich schnell einrichten, indem Sie diese beiden Schritte abschließen.",
    "next": "Weiter",
    "office-label": "Büros auswählen"
  },
  "manage-desks-sidebar": {
    "edit-view": "Ansicht bearbeiten",
    "desk-allocation": "Schreibtisch-Zuweisung",
    "edit-desk": "Schreibtisch bearbeiten",
    "desk-editor": "Schreibtisch-Editor",
    "area-name": "Bereichsname",
    "changed-desks-count": "{{count}} Schreibtisch geändert",
    "changed-desks-count_plural": "{{count}} Schreibtische geändert",
    "save-desk-changes": "Schreibtisch-Änderungen speichern",
    "total-desks": "{{total}} Schreibtische insgesamt",
    "selected-desks": "{{selected}} Schreibtische ausgewählt",
    "select-all-desks": "Alle Schreibtische auswählen",
    "assign-to-indi": "Einzelperson zuweisen",
    "assign-to-team": "Team zuweisen",
    "assign-to-workgroup": "Arbeitsgruppe zuweisen",
    "reset-desks": "Ausgewählte Schreibtische zurücksetzen",
    "assign-desks-to-team": "Schreibtische einem Team zuweisen",
    "assign-desks-to-individual": "Schreibtische einer Einzelperson zuweisen",
    "assign-desks-to-workgroup": "Schreibtische einer Arbeitsgruppe zuweisen",
    "active": "Aktiv"
  },
  "edit-team": {
    "select-office-description": "Büros auswählen, die diesem Team zugeordnet sind",
    "select-departments-description": "Abteilungen auswählen, die diesem Team zugeordnet sind",
    "title": "Team bearbeiten",
    "team-name": "Teamname"
  },
  "team-and-group-radio-button-list": {
    "filter-desks": "Schreibtische nach Teams und Arbeitsgruppen filtern",
    "show-all": "Alle anzeigen"
  },
  "manage-tag-dialog": {
    "delete": "Arbeitsgruppe löschen",
    "update": "Arbeitsgruppe aktualisieren",
    "group-summary": "Es gibt {{count}} Benutzer in dieser Arbeitsgruppe",
    "edit-title": "Arbeitsgruppe bearbeiten",
    "create-title": "Arbeitsgruppe erstellen"
  },
  "manage": {
    "add-new-user": {
      "title": "Teammitglied hinzufügen",
      "subtitle": "Laden Sie bis zu {{count}} Kollegen auf diesem Konto ein",
      "invite-new-user": "Neuen Benutzer einladen",
      "add-existing-user": "Vorhandenen Benutzer hinzufügen",
      "required": "Erforderlich",
      "account": "Konto",
      "free": "Kostenloses Konto",
      "premium": "Premium-Konto",
      "trial": "Testkonto",
      "enterprise": "Enterprise-Konto",
      "total": "Gesamtlizenzen",
      "current": "Aktuelle Benutzer",
      "remaining": "Verbleibende Plätze",
      "team-member-added": "Teammitglied hinzugefügt",
      "user-already-in-account": "Dieses Konto existiert bereits.\nGehen Sie zu Einstellungen > <0>Benutzer verwalten</0>, um die Person dem richtigen Team zuzuweisen.",
      "user-deleted": "Konto existiert bereits.\nDieser Benutzer wurde zuvor gelöscht. Sie können den Zugang unter Einstellungen > Benutzer verwalten > <0>Gelöschte Benutzer</0> wiederherstellen.",
      "paid-account-promote": "Mit einem kostenpflichtigen Konto können Sie so viele Benutzer hinzufügen, wie Sie möchten. Richten Sie eine KOSTENLOSE 30-Tage-Testphase ein, indem Sie eine E-Mail an: hello@team-Today.com senden.",
      "upgrade": "Oder upgraden Sie Ihr Konto in den Einstellungen"
    }
  },
  "header": {
    "meeting-rooms": "Besprechungsräume",
    "leave-planner": "Urlaubsplaner",
    "reports": "Berichte",
    "view-my-bookings": "Meine Buchungen anzeigen",
    "hospitality": "Bewirtung"
  },
  "office-map": {
    "select-office": "Büro auswählen"
  },
  "floor-plan-editor": {
    "open-editor": "Grundriss bearbeiten (Beta)",
    "add-desk": "Schreibtisch hinzufügen",
    "add-area": "Bereich hinzufügen",
    "save": "Speichern",
    "selected": "{{label}} ausgewählt",
    "rename-desk": "Schreibtisch umbenennen",
    "clone-desk": "Schreibtisch klonen",
    "keyboard-hint": "WASD zum Bewegen, Q und E zum Drehen, C zum Klonen",
    "delete-desk": "Schreibtisch löschen",
    "desk-portrait": "Schreibtisch H ({{width}}, {{height}})",
    "desk-landscape": "Schreibtisch Q ({{width}}, {{height}})",
    "corner-desk-portrait": "Eckschreibtisch H ({{width}}, {{height}})",
    "corner-desk-landscape": "Eckschreibtisch Q ({{width}}, {{height}})",
    "rotate-left": "{{degrees}}° nach links drehen",
    "rotate-right": "{{degrees}}° nach rechts drehen",
    "new-area": "Neuer Bereich",
    "no-desks-warning": "Sie müssen zuerst mindestens einen Schreibtisch über die Einstellungen hinzufügen",
    "unsaved-changes": "Sie haben ungespeicherte Grundriss-Änderungen. Möchten Sie die Seite wirklich verlassen?",
    "save-success": "Grundriss-Änderungen gespeichert",
    "save-failed": "Grundriss-Änderungen konnten nicht gespeichert werden",
    "area-create-failed": "Bereich konnte nicht erstellt werden",
    "no-floor-plan": "Dieses Büro hat keinen interaktiven Grundriss."
  },
  "desk-booking": {
    "confirm-booking": "Buchung bestätigen",
    "edit-parking": "Parken bearbeiten",
    "no-space-selected": "Kein Platz ausgewählt"
  },
  "car-parking": {
    "label": "Beschriftung",
    "yaxis": "Y-Achse",
    "width": "Breite",
    "height": "Höhe",
    "rotation": "Rotation",
    "xaxis": "X-Achse",
    "edit-space-title": "Parkplatz bearbeiten",
    "cancel-booking": "Buchung stornieren",
    "am-cancel-booking": "Vormittag stornieren",
    "pm-cancel-booking": "Nachmittag stornieren",
    "are-you-sure-delete": "Sind Sie sicher, dass Sie diesen Parkplatz löschen möchten?"
  },
  "visitor-booking": {
    "daily-visitors": "Bürobesucher",
    "filter": "Besucher filtern",
    "visitors-in-today": "{{count}} Besucher heute",
    "manage-visitors": "Besucher verwalten",
    "visitor-office-title": "Besucher - {{officeName}} Büro",
    "add-visitor": "Besucher hinzufügen",
    "edit-visitor": "Besucher bearbeiten",
    "cancel": "Besucher löschen",
    "visitor-name": "Besuchername",
    "company-name": "Unternehmensname",
    "due-in": "Fällig in",
    "meeting-with": "Besprechung mit",
    "due-today": "Fällig heute",
    "signed-in": "Eingecheckt",
    "signed-out": "Ausgecheckt",
    "no-visitors-today": "Keine Besucher heute",
    "repeat-booking": "Buchung wiederholen",
    "cancel-desk": "Schreibtisch stornieren",
    "book-desk": "Schreibtisch buchen",
    "sign-in": "Einchecken",
    "sign-out": "Auschecken",
    "meeting-room-label": "Besprechungsraum: {{room}}",
    "meeting-room-label-with-time": "Besprechungsraum: {{room}}, {{from}} bis {{to}}"
  },
  "department-dialog": {
    "title": "Abteilung bearbeiten",
    "name": "Name",
    "users": "Anzahl der Benutzer in der Abteilung"
  },
  "allowance": {
    "title": "Urlaubsanspruch",
    "basic": "Grundanspruch",
    "additional": "+ Zusätzliche Tage",
    "total": "Gesamt",
    "used": "Genutzt",
    "remaining": "Verbleibend",
    "justDays": "Tage",
    "days": "{{days}} Tage",
    "breakdown-basic": "Grundanspruch",
    "breakdown-additional": "Zusätzliche Tage",
    "breakdown-carried-over": "Übertrag aus dem Vorjahr",
    "breakdown-expires": "Läuft ab: {{date}}",
    "breakdown-total": "Gesamter Urlaubsanspruch",
    "breakdown-total-expiry-tooltip": "Der Gesamtanspruch enthält Tage, die verfallen können",
    "expiry-report": "Urlaubsverfallsbericht",
    "go-to-reporting": "Zu Berichten",
    "carry-over": "Übertrag",
    "go-to-rollover-management": "Zum Urlaubsübertrag",
    "rollover": "Übertrag",
    "confirm-dialog": {
      "title": "Sind Sie sicher?",
      "description-1": "Dies führt den Urlaubsübertrag für das gesamte Unternehmen durch. Es werden nicht genutzte Urlaubstage von {{previousYear}} nach {{currentYear}} übertragen.",
      "description-2": "Sie können den unternehmensweiten Übertrag für dieses Jahr nicht erneut durchführen.",
      "description-3": "Sie können den Übertrag einzelner Benutzer und andere Kontingente über 'Individuelle Urlaubskontingente bearbeiten' anpassen.",
      "continue": "Ja, Urlaub übertragen",
      "cancel": "Nein, ich bin noch nicht bereit"
    },
    "just-additional": "Zusätzlich",
    "current-carryover": "Aktueller Übertrag",
    "updated": "Aktualisiert",
    "projected-total": "Voraussichtliches Gesamtkontingent für {{year}}",
    "unused-allowance": "Nicht genutztes Kontingent aus {{year}}",
    "days-to-carry-over": "Zu übertragende Tage nach {{year}}`",
    "carried-over": "+ Übertragen",
    "remaining-days": "Verbleibende Tage",
    "standard-remaining-days": "Verbleibende Standardtage",
    "total-days-booked": "Gesamte gebuchte Arbeitstage",
    "carry-over-remaining": "Verbleibender Übertrag",
    "holiday-carry-over-has-been-run": "Der unternehmensweite automatische Übertrag wurde bereits für dieses Urlaubsjahr durchgeführt.<br>Sie können die Kontingente einzelner Personen weiterhin bearbeiten oder uns kontaktieren, um den unternehmensweiten Übertrag erneut durchzuführen.",
    "holiday-carry-over-info": {
      "info": "Der Urlaubsübertragsbericht zeigt eine Vorschau der übertragenen Tage für das nächste Jahr. Tippen Sie auf <strong>Bestätigen</strong> am unteren Bildschirmrand, um die aktualisierten Kontingente für alle Benutzer anzuwenden.",
      "expiry-info": "Der Urlaubsverfallsbericht zeigt eine Vorschau der Tage, die verfallen werden. Tippen Sie auf <strong>Verfall bestätigen</strong> am unteren Bildschirmrand, um die aktualisierten Kontingente für alle Benutzer anzuwenden.",
      "carry-over-left": "Das maximale Übertragslimit beträgt {{carryOverDays}} Tage.",
      "leave-settings": "Um dies anzupassen, gehen Sie zu <0>Urlaubseinstellungen</0>.",
      "carry-over-expires": "Übertrag verfällt am {{carryOverExpiryDate}}",
      "carry-over-does-not-expire": "Übertrag verfällt nicht",
      "view-report": "Bericht anzeigen",
      "carry-over-days-title-additional": "Enthält {{additionalDays}} zusätzliche Tage.",
      "carry-over-days-title-carry": "Enthält {{carriedOverDays}} übertragene Tage.",
      "carry-over-days-explanation": "Um dies anzupassen, gehen Sie zu den individuellen Kontingenten",
      "days-to-carry-over-column-alert-title": "Derzeit auf {{carryOverDays}} Tage Übertrag eingestellt.",
      "days-to-carry-over-column-alert-explanation": "Wenn diese Zahlen unterschiedlich sind, wurde seit der letzten Ausführung des Übertragsberichts Urlaub hinzugefügt.",
      "carry-over-report-title": "Urlaubsübertragsbericht"
    },
    "holiday-expiry-info": {
      "carry-over-left": "Das maximale Übertragslimit beträgt {{carryOverDays}} Tage.",
      "leave-settings": "Um dies anzupassen, gehen Sie zu <0>Urlaubseinstellungen</0>.",
      "carry-over-expires": "Übertrag verfällt am {{carryOverExpiryDate}}",
      "carry-over-does-not-expire": "Übertrag verfällt nicht",
      "view-report": "Bericht anzeigen",
      "carry-over-days-title": "Enthält {{additionalDays}} zusätzliche Tage.",
      "carry-over-days-explanation": "Um dies anzupassen, gehen Sie zu den individuellen Kontingenten"
    }
  },
  "leave-type-dialog": {
    "title": "Urlaubsart auswählen"
  },
  "languages": {
    "english": "Englisch",
    "french": "Französisch",
    "german": "Deutsch",
    "spanish": "Spanisch"
  },
  "calendar-sync": {
    "turn-on": "Einschalten",
    "active": "Kalendersynchronisation aktiv",
    "loading": "Kalendersynchronisation wird geladen",
    "none": "Keine Kalendersynchronisation",
    "disabled": "Kalendersynchronisation deaktiviert",
    "unknown": "Status unbekannt"
  },
  "whereabouts-labels": {
    "COMPANY_HOLIDAY": "Firmenfeiertag",
    "HOLIDAY_REJECTED": "Urlaub (Abgelehnt)",
    "HOLIDAY_APPROVED": "Urlaub (Genehmigt)",
    "NOT_WORKING": "Kein Arbeitstag",
    "UNKNOWN": "Unbekannt",
    "HOLIDAY": "Urlaub",
    "HOLIDAY_PENDING": "Urlaub (Ausstehend)",
    "HOME": "Arbeit von zu Hause",
    "OFFICE": "Im Büro"
  },
  "user-hover": {
    "add-favourites": "Zu Favoriten hinzufügen",
    "remove-favourites": "Aus Favoriten entfernen",
    "leave": "Urlaub anzeigen"
  },
  "hospitality": {
    "add-from-menu": "Artikel aus dem Menü hinzufügen",
    "add-instructions": "Anweisungen hinzufügen",
    "add-special-items": "Sonderartikel hinzufügen",
    "confirm-instructions": "Anweisungen bestätigen",
    "instructions-title": "Anweisungen hinzufügen",
    "instructions-description": "Notizen hinzufügen (z.B. Ernährungsvorlieben)",
    "cost-center": "Kostenstelle",
    "choose-items": "Artikel aus dem Menü auswählen",
    "confirm": "Auswahl bestätigen",
    "add-item": "Artikel hinzufügen",
    "special-hospitality-item-title": "Speziellen Bewirtungsartikel hinzufügen",
    "food-cost": "Lebensmittelkosten (€)",
    "quantity": "Menge",
    "delivery": "Lieferung",
    "item": "Artikel",
    "total-cost": "Gesamtkosten",
    "no-items": "Es wurden keine Artikel zu dieser Besprechung hinzugefügt.",
    "not-started": "Nicht begonnen",
    "in-progress": "In Bearbeitung",
    "done": "Erledigt",
    "report-day": "Tagesbericht herunterladen.csv",
    "report-week": "Wochenbericht herunterladen.csv",
    "report-month": "Monatsbericht herunterladen.csv",
    "no-bookings": "Keine Bewirtungsbuchungen",
    "no-bookings-description": "Fügen Sie Bewirtung hinzu, wenn Sie eine Besprechung buchen",
    "add-visitor": {
      "title": "Besucher hinzufügen",
      "add-visitor": "Besucher hinzufügen",
      "company": "Firmenname",
      "email": "E-Mail-Adresse (nur wenn Besprechungseinladung direkt gesendet wird)",
      "due-in": "Erwartet um",
      "meeting-with": "Besprechung mit"
    }
  }
}
